import { Component, Input, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { DispatcherHomeService } from './dispatcherhome.service';
import { MqttService } from '../../Utils/mqtt.service';
import { Router } from '@angular/router';
import * as myGlobals from '../../globals';
import { LanguageService } from '../../language.service';
import { Paho } from 'ng2-mqtt/mqttws31';
import { mapStyle } from '../../Utils/MapStyles';
import { ConfigService } from '../../config.service';
import { TranslateService } from '@ngx-translate/core';
// import { LoginService }   from './login.service';
declare const jQuery: any;
declare const google: any;
declare const $: any;
declare const moment: any;
declare const swal: any;
declare const toastr: any;
//  var mapboxgl = require('mapbox-gl');

@Component({
  selector: 'dispatcherhome',
  animations: [
    trigger('myAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('400ms', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('400ms', style({ transform: 'translateY(100%)', opacity: 0 }))
      ])
    ])
  ],
  templateUrl: './dispatcherhome.component.html',
  styleUrls: ['./dispatcherhome.component.css']
})
export class DispatcherHomeComponent implements OnInit {
  fp_incr: any;
  pickuplat;
  pickuplong;
  droplat;
  droplong;
  photo;
  vechiletypes: any;
  removeFav: Boolean = false;
  approx: any;
  otp_entered: any;
  favDiverId: any;
  vehicle_device_id: any;
  info;
  Path;
  zpath: any;
  data: any;
  data1 = [];
  data2 = [];
  data3 = [];
  getdata;
  own_lat_long: any;
  own_later_date;
  rec_name: any;
  rec_number: any;
  rec_mail: any;
  rec_lat_long: any;
  product_det: any;
  product_qty: any;
  product_wgt: any;
  vechicle_type: any;
  passDetailsContent: any;
  dynamic_latlong: any;
  file: any;
  fname_b: any;
  map: any;
  marker: any;
  style: any;
  fmail_b: any;
  pubnub: any;
  current_time: any;
  current_time_var: any;
  public submitted = false;
  assigned_count: any = 0;
  assigned_full_count: any = 0;
  completed_count: any = 0;
  mapr: any;
  page_index: any = 0;
  route_map_lt;
  route_map_lng;
  route_map_driver_lat;
  route_map_driver_lng;
  directions: any;
  polyline: any;
  // GODS VIEW MARKERS VARIABLES
  drivers_list = [];
  markers_number = 0;
  drivers_layer: any;
  drivers_lat_long = [];
  overlayMaps: any;
  route_markers = [];
  driver_lat_route: any;
  driver_lng_route: any;
  driver_markers_inst: any;
  drivers_timings = [];
  driver_timing_singal: any;
  driver_online_offline: any;
  driver_online_email: any;
  difference_of_timings: any;
  picker_date: any;
  drop_date: any;
  picker_bool = false;
  server_time: any;
  first_render = 0;
  fphone_b: any;
  online_drivers = [];
  offline_drivers = [];
  total_drivers = [];
  ent_lati = '19.6008014678955';
  ent_long = '-99.2285003662109';
  driver_latlong_change: any;
  map1: any;
  allroute_markers = [];
  directionsDisplay: any;
  myname = sessionStorage.getItem('custname');
  myphn = sessionStorage.getItem('custphn');
  mymail = sessionStorage.getItem('custmail');
  changing_location_data = [];
  changing_location_status: any;
  current_driver_marker: any;
  path_his = [];
  current_location_marker: any;
  current_driver = {
    Device_type_: '',
    a: '',
    app_version: '',
    battery_Per: '',
    bid: '',
    lg: '',
    lt: '',
    location_check: '',
    st: ''
  };
  allpath_markers = [];
  show_drivers = false;
  cancellation_bid: any;
  cancel_reasons = [];
  currency: any;
  pathline: any;
  onLoadLatitude: any;
  onLoadLongitude: any;
  /** CANCEL BOOKING VARIABLES*/
  cancellation_fee: any;
  cancellation_reason: any;
  //  ent_lati = "12.9716";
  //  ent_long =  "77.5946";

  // new booking details

  offers = [];
  past_jobs = [];
  showbooking_content: any;
  map_loader = true;
  total_offers_count = 0;
  offers_incall = false;
  offers_limit = 30;
  offers_skip = 0;

  // my booking details

  assigned_jobs = [];
  total_assigned_count = 0;
  assigned_incall = false;
  assigned_limit = 50;
  assigned_skip = 0;

  // negotiation variables

  shownegos_content: any;
  negotiations = [];
  new_negotiations = [];
  old_negotiations = [];
  negotiation_bid: any;
  current_bid_item: any;
  counter_price: any;
  negos_loader = false;
  negos_history = [];
  in_history_bid = {
    lprice: '',
    _id: ''
  };
  accept_offer_details = {
    aPrice: '',
    img: '',
    latLong: '',
    mPrice: '',
    name: '',
    rating: '',
    status: '',
    time: '',
    _id: '',
    driverId: ''
  };
  current_assigned_count: any;
  // New api booking variables
  unassignedCount = 0;
  assignedCount = 0;
  pastCount = 0;
  bookcomplete: any;

  mqttStatus: any;
  mqttlat: any;
  mqttlong: any;
  mqttlatlong: any = [];
  client: any;
  showingVehicleMarker: any;
  aws = myGlobals.aws;
  intervalTimersArray = [];
  bookingLoader = false;
  invoiceUrl = myGlobals.INVOICE_URL;
  languageTexts: any;
  constructor(
    private _dispatcherHomeService: DispatcherHomeService,
    private _router: Router,
    private _cookie: ConfigService,
    private _missionService: MqttService,
    private languageService: LanguageService,
    private translate: TranslateService
  ) {
    let lang = this._cookie.getItem('lang');
    console.log('lang', lang);
    translate.getTranslation(lang).subscribe((res: string) => {
      console.log("translate", res);
      this.languageTexts = res;
      //=> 'hello world'
    });
    console.log('languageTexts', this.languageTexts)
    _missionService.missionAnnounced$.subscribe((data: any) => {
      // console.log('mqtt data', JSON.parse(data));
      try {
        data = JSON.parse(data);
      } catch (err) {
        data = data;
      }

      if (data.hasOwnProperty('negotiation')) {
        if (data.negotiation.hasOwnProperty('status') == false) {
          data.status = data.status;
        } else {
          data.status = data.negotiation.status;
        }
      }
      const status = data.status;
      if (status === 16) {
        return;
      }
      if (
        status == 1 ||
        status == 101 ||
        status == 102 ||
        status == 103 ||
        status == 104
      ) {
        $(`#assigned_but`)
          .addClass('animated bounce')
          .one('animationend', function () {
            $(this).removeClass('animated bounce');
          });
      } else {
        $(`#un_assigned_but`)
          .addClass('animated bounce')
          .one('animationend', function () {
            $(this).removeClass('animated bounce');
          });
      }

      switch (status) {
        case 1:
          this.new_job(data);
          // toastr["success"]("<h5>New job posted</h5>");
          break;
        case 101:
          this.driver_accepted(data);
          break;
        case 102:
          console.log('driver counter')
          this.driver_counter(data);
          break;
        case 103:
          this.customer_counter(data);
          break;
        case 104:
          this.customer_accepted(data);
          break;
        case 2:
          this.change_booking_assigned(data);
          break;
        case 4:
        case 5: // driver started
          this.driverCancelled(data);
          break;
        case 6: // driver on the way
          this.driverOnTheWay(data);
          break;
        case 7: // driver arrived
          this.driverArrived(data);
          // data.status == 7 ? $('#otp_popup').modal('show') : '';
          break;
        case 8: // driver loaded
        case 9: // trip started
          this.tripStarted(data);
          break;
        case 10: // reached to drop location
          this.reachedDrop(data);
          break;
        case 11: //unloaded
          this.deliveryUnloaded(data);
          break;
        case 12: // completed
          this.driverCompleted(data);
          this.pending_reviews();
          break;
        case 13: // expired
          this.expireBooking(data);
          break;
        // case 16:// driver unloaded
        //   this.changeBookingStatus(data);
        //   break;
        case 10:
          this.bookingCompleted(data);
          break;
        case 14:
          this.biddingStopped(data);
          break;
        case 17:
          swal({
            //this.languageTexts.swalTexts['enterWeight']
            title: this.languageTexts.swalTexts['reloadPageGoogle'],
            text:
              this.languageTexts.swalTexts['areYouSure'],
            icon: 'warning',
            buttons: true,
            dangerMode: true
          }).then(willDelete => {
            if (willDelete) {
              window.location.reload();
            } else {
              swal(this.languageTexts.swalTexts['enterWeight']);
            }
          });
          break;
      }

      //  console.log("onlinedrivers++++++++++++++++++++++++++++",data);
      //  if(this.changing_location_data.length==0){
      //          this.changing_location_data.push(data);
      //          this.changindriver_loc(data);
      //  }
      //  else{
      //          for(var inst=0;inst<this.changing_location_data.length;inst++){
      //            if(this.changing_location_data[inst].bid==data.bid){
      //             this.changing_location_data.splice(inst,1);
      //             this.changing_location_data.splice(0, 0,data);
      //             this.changindriver_loc(data);
      //              break;
      //            }
      //            else if(inst == this.changing_location_data.length-1){
      //              if(this.changing_location_data[inst].bid!=data.bid){
      //              this.changing_location_data.push(data);
      //              this.changindriver_loc(data);
      //              break;
      //              }
      //              else{
      //              this.changing_location_data.splice(inst,1);
      //              this.changing_location_data.splice(0, 0,data);
      //              this.changindriver_loc(data);
      //              break;
      //              }
      //            }

      // if(this.current_driver.bid==this.changing_location_data[inst].bid){
      // this.current_driver.Device_type_ = this.changing_location_data[inst].Device_type_;
      // this.current_driver.a = this.changing_location_data[inst].a;
      // this.current_driver.app_version = this.changing_location_data[inst].app_version;
      // this.current_driver.battery_Per = this.changing_location_data[inst].battery_Per;
      // this.current_driver.lg = this.changing_location_data[inst].lg;
      // this.current_driver.lt = this.changing_location_data[inst].lt;
      // this.current_driver.location_check = this.changing_location_data[inst].location_check;
      // this.current_driver.st = this.changing_location_data[inst].st;
      // }
      //         }
      //  }
    });
  }

  mqttsubscribe(driver, res) {
    const channel = driver.driverDetails.mqttLocationTopic;
    // const driverLatLongs = driver.driverDetails.driversLatLongs.split(',');
    const pos1 = new google.maps.LatLng(
      parseFloat(res.driverLocation.latitude),
      parseFloat(res.driverLocation.longitude)
    );
    this.showingVehicleMarker = new google.maps.Marker({
      position: pos1,
      icon: {
        url: driver.vehicleType.vehicleMapIcon,
        scaledSize: new google.maps.Size(80, 80)
      },
      map: this.map1
    });
    this.showingVehicleMarker.id = driver.driverDetails.driverId;
    // this.allroute_markers.push(this.showingVehicleMarker);
    this.client = new Paho.MQTT.Client(
      myGlobals.MQTT_HOST,
      'myClientId' + new Date().getTime()
    );
    this.client.onConnectionLost = (responseObject: Object) => {
      console.log('Connection lost.', responseObject);
      const options = {
        userName: myGlobals.MQTT_USERNAME,
        password: myGlobals.MQTT_PASSWORD,
        useSSL: myGlobals.MQTT_USESSL,
        timeout: 60,
        // Gets Called if the connection has successfully been established
        onSuccess: () => {
          console.log('connected');
          this.client.subscribe(sessionStorage.getItem('mqtt'), { qos: 2 });
          // this._client.subscribe('godsview/location', { qos: 2 });
        },
        // Gets Called if the connection could not be established
        onFailure: function (message) {
          console.log('Connection failed:.' + message.errorMessage);
          //                alert("Connection failed: " + message.errorMessage);
        }
      };
      !this.client.isConnected() ? this.client.connect(options) : '';
    };

    this.client.onMessageArrived = (message: Paho.MQTT.Message) => {
      // console.log("JSON.parse(message.payloadString)", JSON.parse(message.payloadString));
      const response = JSON.parse(message.payloadString);
      const responseDriverId = response.driverId;
      // console.log('this.showingVehicleMarker', this.showingVehicleMarker);
      if (this.showingVehicleMarker) {
        if (
          this.showingVehicleMarker.id == response.driverId &&
          response.transit == 1
        ) {
          const latlng = new google.maps.LatLng(
            response.latitude,
            response.longitude
          );
          this.map1.setCenter(latlng);
          this.showingVehicleMarker.setPosition(latlng);
          const marker = new google.maps.Marker({
            position: latlng,
            icon: myGlobals.pathicn,
            map: this.map1
          });
          this.path_his.push(marker);
          const path = this.pathline.getPath();
          path.push(latlng);
          // Because path is an MVCArray, we can simply append a new coordinate
          // and it will automatically appear.
        }
      } else {
        console.warn('Disconneted from Live track');
        this.client.unsubscribe(channel);
      }
    };

    const options = {
      userName: myGlobals.MQTT_USERNAME,
      password: myGlobals.MQTT_PASSWORD,
      useSSL: myGlobals.MQTT_USESSL,
      timeout: 60,
      keepAliveInterval: 15,

      // Gets Called if the connection has successfully been established

      onSuccess: () => {
        console.log('connected');
        this.client.subscribe(channel, { qos: 2 });
        // this.client.subscribe('godsview/location', { qos: 2 });
      },
      // Gets Called if the connection could not be established
      onFailure: function (message) {
        // alert("failure");
        console.log('Connection failed:.' + message.errorMessage);
        //                alert("Connection failed: " + message.errorMessage);
      }
    };
    !this.client.isConnected() ? this.client.connect(options) : '';
  }

  pickupDocsUpdated(data) {
    const indexOfBooking = this.assigned_jobs.findIndex(
      i => i.bookingId === data.bookingId
    );
    if (indexOfBooking != -1) {
      for (
        let pickDocs = 0;
        pickDocs < data.bookingDocuments.pickup.length;
        pickDocs++
      ) {
        this.assigned_jobs[indexOfBooking].bookingDocuments.pickup.push(
          data.bookingDocuments.pickup[pickDocs]
        );
      }
    }

    if (indexOfBooking === 0) {
      setTimeout(() => {
        $('#body_' + data.bookingId).addClass('blink');
      }, 1000);
    } else {
      if (indexOfBooking != -1) {
        const bookingData = this.assigned_jobs[indexOfBooking];
        this.assigned_jobs.splice(indexOfBooking, 1);
        this.assigned_jobs.splice(0, 0, bookingData);
        setTimeout(() => {
          $('#body_' + data.bookingId).addClass('blink');
        }, 1000);
      } else {
        // call single booking
      }
    }
  }
  shiftBookingToTop(data) {
    const indexOfBooking = this.assigned_jobs.findIndex(
      i => i.bookingId === data.bookingId
    );
    console.log('shiftBookingToTop', indexOfBooking);
    // if already at start, nothing to do
    if (indexOfBooking != -1) {
      this.assigned_jobs[indexOfBooking].bookingStatus = data.status;
      this.assigned_jobs[indexOfBooking].bookingStatusText = data.statusText;
      switch (data.status) {
        case 7:
          this.assigned_jobs[
            indexOfBooking
          ].timeStamp.arrived = moment().format('DD MMM  YYYY, hh : mm a');
          // this.showbooking_content = this.assigned_jobs[indexOfBooking];
          // data.status == 7 ? $('#otp_popup').modal('show') : '';
          break;
        case 9:
          this.assigned_jobs[
            indexOfBooking
          ].timeStamp.journeyStart = moment().format('DD MMM  YYYY, hh : mm a');
          break;
        case 10:
          this.assigned_jobs[
            indexOfBooking
          ].timeStamp.reachedDrop = moment().format('DD MMM  YYYY, hh : mm a');
          break;
        case 11:
          this.assigned_jobs[
            indexOfBooking
          ].timeStamp.unloaded = moment().format('DD MMM  YYYY, hh : mm a');
          break;
      }
      console.log(this.assigned_jobs[indexOfBooking]);
      if (indexOfBooking === 0) {
        setTimeout(() => {
          $('#body_' + data.bookingId).addClass('blink');
        }, 1000);
      } else {
        if (indexOfBooking != -1) {
          const bookingData = this.assigned_jobs[indexOfBooking];
          this.assigned_jobs.splice(indexOfBooking, 1);
          this.assigned_jobs.splice(0, 0, bookingData);
          setTimeout(() => {
            $('#body_' + data.bookingId).addClass('blink');
          }, 1000);
        } else {
          // call single booking
        }
      }
    } else if (indexOfBooking == -1) {
      this._dispatcherHomeService
        .negotiations({
          bookingId: data.bookingId,
          status: 2
        })
        .subscribe((res: any) => {
          console.log('completedbooking--->', res);
          const bookingData = res.dataForDispatcher;
          if (bookingData.bookingDateTimestamp != '0') {
            bookingData.bookingDateTimestamp = moment
              .unix(bookingData.bookingDateTimestamp)
              .format('DD MMM  YYYY, hh : mm a');
          }
          if (bookingData.deliveryDateTimestamp != '0') {
            bookingData.deliveryDateTimestamp = moment
              .unix(bookingData.deliveryDateTimestamp)
              .format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.created != '0') {
            bookingData.timeStamp.created = moment(
              bookingData.timeStamp.created * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.expired != 0) {
            bookingData.timeStamp.expired = moment(
              bookingData.timeStamp.expired * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.cancelled != 0) {
            bookingData.timeStamp.cancelled = moment(
              bookingData.timeStamp.cancelled * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.accepted != 0) {
            bookingData.timeStamp.accepted = moment(
              bookingData.timeStamp.accepted * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.arrived != 0) {
            bookingData.timeStamp.arrived = moment(
              bookingData.timeStamp.arrived * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.reachedDrop != 0) {
            bookingData.timeStamp.reachedDrop = moment(
              bookingData.timeStamp.reachedDrop * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.onTheWay != 0) {
            bookingData.timeStamp.onTheWay = moment(
              bookingData.timeStamp.onTheWay * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.unloaded != 0) {
            bookingData.timeStamp.unloaded = moment(
              bookingData.timeStamp.unloaded * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.journeyComplete != 0) {
            bookingData.timeStamp.journeyComplete = moment(
              bookingData.timeStamp.journeyComplete * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (bookingData.timeStamp.journeyStart != 0) {
            bookingData.timeStamp.journeyStart = moment(
              bookingData.timeStamp.journeyStart * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          this.assigned_jobs.unshift(bookingData);
          setTimeout(() => {
            $('#body_' + bookingData.bookingId).addClass('blink');
          }, 100);
        });
    }
  }
  // customer counter
  customer_counter(data) {
    console.log(
      'customer counter data-->',
      data,
      this.showbooking_content.bookingId
    );
    this.negotiation_bid = data.bookingId;
    if (this.showbooking_content.bookingId == this.negotiation_bid) {
      console.log(
        'Negosiations--->',
        this.negotiations,
        this.old_negotiations,
        this.new_negotiations
      );
      const index_newnegos = this.new_negotiations.findIndex(
        i => i.driverId == data.negotiation.driverId
      );
      const index_negos = this.negotiations.findIndex(
        i => i.driverId == data.negotiation.driverId
      );
      if (index_newnegos !== -1) {
        this.new_negotiations[index_newnegos].status = data.negotiation.status;
        this.new_negotiations[index_newnegos].offerPriceCustomer =
          data.negotiation.offerPriceCustomer;
        console.log(this.negotiations, index_negos, index_newnegos);
        this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
        this.old_negotiations.push(this.new_negotiations[index_newnegos]);
        this.new_negotiations.splice(index_newnegos, 1);
        console.log(
          'negositations',
          this.old_negotiations,
          this.new_negotiations
        );
        this.counter_price = '';
        const biddingPrice = data.negotiation.offerPriceCustomer;
        const biddingData = {
          bookingId: this.negotiation_bid,
          offerPrice: biddingPrice
        };
        this.changeCustomerOffer(biddingData);
        this.counter_price = '';
      }

      // const indexOfBooking = this.offers.findIndex(i => i.bookingId == parseInt(data.bookingId));
      // if (this.offers[indexOfBooking].negotiationData.bestBidCustomer < data.offerPrice) {
      //   this.offers[indexOfBooking].negotiationData.bestBidCustomer = data.offerPrice;
      // }

      // moving bid to past
      // if (this.showbooking_content.bookindId == this.negotiation_bid) {
      //   // alert();
      //   const index_newnegos = this.new_negotiations.findIndex(i => i.bookindId == this.negotiation_bid);
      //   const index_negos = this.negotiations.findIndex(i => i._id == data.negotiation.driverId);
      //   this.new_negotiations[index_newnegos].status = 104;
      //   this.new_negotiations[index_newnegos].aPrice = data.negotiation.offerPriceCustomer;
      //   this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
      //   this.old_negotiations.push(this.new_negotiations[index_newnegos]);
      //   this.new_negotiations.splice(index_newnegos, 1);
      // }
      console.log('acceptoffer', this.new_negotiations);
      $(`#body_${this.negotiation_bid}`).trigger('click');
    }
  }
  customer_accepted(data) {
    // move to past
    console.log('2222', data);
    this.negotiation_bid = data.bookingId.toString();
    $('#body_' + this.negotiation_bid).removeClass('blink');
    if (this.showbooking_content.bookingId == this.negotiation_bid) {
      $('#body_' + this.negotiation_bid).trigger('click');
      // if (this.accept_offer_details['handShakeDone'] == 0) {
      //   const index_newnegos = this.new_negotiations.findIndex(i => i.bookindId == this.negotiation_bid);
      //   const index_negos = this.negotiations.findIndex(i => i._id == data.negoitation.driverId);
      //   this.new_negotiations[index_newnegos].status = data.negoitation.status;
      //   this.new_negotiations[index_newnegos].aPrice = this.new_negotiations[index_newnegos].mPrice;
      //   this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
      //   this.old_negotiations.push(this.new_negotiations[index_newnegos]);
      //   this.new_negotiations.splice(index_newnegos, 1);
      // }
    }

    // handshake
    // if (this.accept_offer_details['handShakeDone'] == true) {
    console.log('data.negotiatio', data.negotiation);
    if (data.negotiation.handShake == 'false') {
      // alert('if part');
      console.log('this.new_negotiations', this.new_negotiations);
      console.log('this.old_negotiations', this.old_negotiations);

      // const indexOfold = this.new_negotiations.findIndex(i => i.driverId == this.accept_offer_details.driverId);
      // this.new_negotiations[indexOfold].status = 104;
      // this.new_negotiations[indexOfold].time = 'a few seconds ago';
      // this.old_negotiations.push(this.new_negotiations[indexOfold]);
      // this.new_negotiations.splice(indexOfold, 1);
    } else {
      // alert('else part');
      this.change_booking_assigned(this.showbooking_content);
    }
  }

  driverCancelled(data) {
    //driver cancelled
    $('#' + data.bookingId).addClass('remove');
    if (this.showbooking_content != undefined) {
      if (this.showbooking_content.bookingId == data.bookingId) {
        this.showbooking_content = '';
        this.passDetailsContent = '';
        this.new_negotiations = [];
        this.old_negotiations = [];
        this.negotiations = [];
      }
    }
    setTimeout(() => {
      const indexofBooking = this.assigned_jobs.findIndex(
        i => i.bookingId === data.bookingId
      );
      if (indexofBooking != -1) {
        console.log(this.assigned_jobs[indexofBooking]);
        this.assigned_jobs[indexofBooking].bookingStatus = 5;
        this.assigned_jobs[indexofBooking].bookingStatusText =
          'Driver Cancelled';
        this.past_jobs.splice(0, 0, this.assigned_jobs[indexofBooking]);
        this.assigned_jobs.splice(indexofBooking, 1);
        this.assignedCount--;
        this.pastCount++;
      } else {
        // call single booking and push to past bookings
      }
    }, 1000);
  }

  driverOnTheWay(data) {
    console.log('driverOnTheWay--------->', data);
    this.shiftBookingToTop(data);
  }
  driverArrived(data) {
    console.log('driverArrived--------->', data);
    if (data.bookingDocuments.pickup.length == 0) {
      this.shiftBookingToTop(data);
    } else {
      this.pickupDocsUpdated(data);
    }
  }
  tripStarted(data) {
    this.shiftBookingToTop(data);
  }
  biddingStopped(data) {
    console.log('databidingexpired');
  }
  reachedDrop(data) {
    this.shiftBookingToTop(data);
  }
  deliveryUnloaded(data) {
    this.shiftBookingToTop(data);
  }
  driverCompleted(data) {
    const indexofBooking = this.assigned_jobs.findIndex(
      i => i.bookingId === data.bookingId
    );
    $('#' + data.bookingId).addClass('remove');
    if (this.showbooking_content != undefined) {
      if (this.showbooking_content.bookingId == data.bookingId) {
        this.showbooking_content = '';
        this.passDetailsContent = '';
        this.new_negotiations = [];
        this.old_negotiations = [];
        this.negotiations = [];
        this.clearallpassdetails();
        this.getBookingDetails();
      }
    }
    if (indexofBooking != -1) {
      setTimeout(() => {
        this.assigned_jobs.splice(indexofBooking, 1);
      }, 1000);
    }
    if (this.pathline != undefined) {
      this.pathline.setMap(null);
    }
    this._dispatcherHomeService
      .negotiations({
        bookingId: data.bookingId,
        status: 2
      })
      .subscribe((res: any) => {
        console.log('completedbooking--->', res);
        const bookingData = res.dataForDispatcher;
        if (bookingData.bookingDateTimestamp != '0') {
          bookingData.bookingDateTimestamp = moment
            .unix(bookingData.bookingDateTimestamp)
            .format('DD MMM  YYYY, hh : mm a');
        }
        if (bookingData.deliveryDateTimestamp != '0') {
          bookingData.deliveryDateTimestamp = moment
            .unix(bookingData.deliveryDateTimestamp)
            .format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.created != '0') {
          bookingData.timeStamp.created = moment(
            bookingData.timeStamp.created * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.expired != 0) {
          bookingData.timeStamp.expired = moment(
            bookingData.timeStamp.expired * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.cancelled != 0) {
          bookingData.timeStamp.cancelled = moment(
            bookingData.timeStamp.cancelled * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.accepted != 0) {
          bookingData.timeStamp.accepted = moment(
            bookingData.timeStamp.accepted * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.arrived != 0) {
          bookingData.timeStamp.arrived = moment(
            bookingData.timeStamp.arrived * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.reachedDrop != 0) {
          bookingData.timeStamp.reachedDrop = moment(
            bookingData.timeStamp.reachedDrop * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.onTheWay != 0) {
          bookingData.timeStamp.onTheWay = moment(
            bookingData.timeStamp.onTheWay * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.unloaded != 0) {
          bookingData.timeStamp.unloaded = moment(
            bookingData.timeStamp.unloaded * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.journeyComplete != 0) {
          bookingData.timeStamp.journeyComplete = moment(
            bookingData.timeStamp.journeyComplete * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        if (bookingData.timeStamp.journeyStart != 0) {
          bookingData.timeStamp.journeyStart = moment(
            bookingData.timeStamp.journeyStart * 1000
          ).format('DD MMM YYYY, hh : mm a');
        }
        this.past_jobs.splice(0, 0, bookingData);
        this.pastCount++;
        this.assignedCount--;
        // if(this.showbooking_content.bookingId == data.bookingId){
        //   $("#" + data.bookingId).trigger('click');
        // }
      });
  }
  handleStatus(statuscode) {
    $('.modal').modal('hide');
    if (statuscode >= 500) {
      statuscode = 500;
    }
    switch (statuscode) {
      case 400:
        toastr['warning']('Bad request');
        break;
      case 401:
        //  clearInterval(this.authorize_call);
        sessionStorage.removeItem('authtoken');
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('phone');
        localStorage.removeItem('authToken');
        sessionStorage.clear();
        this._router.navigate(['login']);
        // toastr['warning']('You have been logged out. Please login to continue');
        break;
      case 500:
        toastr['warning']('Could not connect to server');
        break;
    }
  }

  changeBookingStatus(data) {
    const indexOfbookings = this.assigned_jobs.findIndex(i => i.id === data.id);
    $('#body_' + data.id).addClass('blink');
    if (indexOfbookings !== -1) {
      this.assigned_jobs[indexOfbookings].status = data.status;
      this.assigned_jobs[indexOfbookings].statusTxt = data.statusTxt;
      data.timeConverted = moment
        .unix(data.time / 1000)
        .format('DD MMM  YYYY, hh : mm a');
      if (this.assigned_jobs[indexOfbookings].activities == undefined) {
        this.assigned_jobs[indexOfbookings].activities = [];
      }
      this.assigned_jobs[indexOfbookings].activities.push(data);
    }
  }
  bookingCompleted(data) {
    const indexOfbookings = this.offers.findIndex(i => i.id === data.bid);
  }
  changindriver_loc(data) {
    if (this.current_driver.bid == data.bid) {
      if (
        this.changing_location_status == 6 ||
        this.changing_location_status == 7 ||
        this.changing_location_status == 8 ||
        this.changing_location_status == 9 ||
        this.changing_location_status == 16
      ) {
        this.current_driver.Device_type_ = data.Device_type_;
        this.current_driver.a = data.a;
        this.current_driver.app_version = data.app_version;
        this.current_driver.battery_Per = data.battery_Per;
        this.current_driver.bid = data.bid;
        this.current_driver.lg = data.lg;
        this.current_driver.lt = data.lt;
        this.current_driver.location_check = data.location_check;
        this.current_driver.st = data.st;
        const latlng = new google.maps.LatLng(data.lt, data.lg);
        this.current_driver_marker.setPosition(latlng);
        const latlongobj = {
          lat: this.current_driver.lt,
          lng: this.current_driver.lg
        };
        this.allpath_markers.push(latlongobj);
        const pos1 = new google.maps.LatLng(
          parseFloat(this.current_driver.lt),
          parseFloat(this.current_driver.lg)
        );
        const infowindow = new google.maps.InfoWindow();
        const marker = new google.maps.Marker({
          position: pos1,
          icon: myGlobals.pathicn,
          map: this.map1
        });
        const content = this.current_driver.st;
        google.maps.event.addListener(
          marker,
          'mouseover',
          (function (marker, content, infowindow) {
            return function () {
              infowindow.setContent(content);
              infowindow.open(this.map1, marker);
            };
          })(marker, content, infowindow)
        );
        this.path_his.push(marker);
        const lineSymbol = {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
        };
        this.pathline = new google.maps.Polyline({
          path: this.allpath_markers,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          strokeColor: '#4eff04',
          icons: [
            {
              icon: lineSymbol,
              repeat: '300px',
              strokeColor: 'red',
              offset: '100%'
            }
          ],
          map: this.map1
          // editable: true,
        });
      }
    }
  }

  fileEvent(fileInput: any) {
    this.file = fileInput.target.files[0];
  }

  hideShow_job() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#job_details_button').addClass('active');
    $('.details_description').show();
  }
  hideShow_activity() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#activity_timeline_button').addClass('active');
    $('.details_description2').show();
  }
  hideShow_path() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#path_history_button').addClass('active');
    $('.details_description3').show();
  }
  hideShow_docs() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#documents_show').addClass('active');
    $('.details_description4').show();
  }
  hideShow_invoice() {
    $('.tabs_details').hide();
    $('.details_but_sytle').removeClass('active');
    $('#invoice_show').addClass('active');
    $('.details_description5').show();
  }

  cancellationFee(bid) {
    this._dispatcherHomeService
      .cancelfees({
        bookingId: bid
      })
      .subscribe((res: any) => {
        console.log('cancellationFee', res);
        this.cancellation_reason = res.message;
      });
  }

  cancelReason(booking) {
    const bid = booking.bookingId;
    this.cancellation_bid = bid;
    let bookingStatus;
    // if the booking is assigned then call cancellation fee
    console.log('booking', booking, this.cancellation_bid);
    if (booking.bookingStatus == 1) {
      this.cancellation_fee = 0;
      bookingStatus = 2;
      // this.cancelappt();
      // return;
    } else {
      bookingStatus = 1;
      this.cancellationFee(bid);
    }

    $('.booking_loader_parent').show();
    this.cancel_reasons = [];
    this.cancellation_bid = '';
    this._dispatcherHomeService.cancelreasons(bookingStatus).subscribe(
      (res: any) => {
        console.log('cancelReason', res);
        $('.booking_loader_parent').hide();
        res.data.bid = bid;
        for (let inst = 0; inst < res.data.length; inst++) {
          this.cancel_reasons.push(res.data[inst]);
        }
        console.log('this.cancel_reasons', this.cancel_reasons);
        // this.cancel_reasons = res.data.reasons;
        $('#appcancel_rs').modal('show');
        $('#details_task').modal('hide');
      },
      err => {
        $('.booking_loader_parent').hide();
        const error = err.error;
        const listErr = error.statusCode;
        this.handleStatus(error.statusCode);
      }
    );
  }

  // cancellation after accept
  cancelserviceAfterAccept() { }

  live_path_show(item) {
    this.clearallpassdetails();
    setTimeout(() => {
      this.map_loader = false;
      const pickupMarkerLoc = new google.maps.LatLng(
        item.pickup.location.latitude,
        item.pickup.location.longitude
      );
      const driverMarkerLoc = new google.maps.LatLng(
        item.drop.location.latitude,
        item.drop.location.longitude
      );
      const pickupMarker = new google.maps.Marker({
        position: pickupMarkerLoc,
        icon: myGlobals.pickupicn,
        map: this.map1
      });
      this.allroute_markers.push(pickupMarker);
      const driverMarker = new google.maps.Marker({
        position: driverMarkerLoc,
        icon: myGlobals.dropupicn,
        map: this.map1
      });
      this.allroute_markers.push(driverMarker);
    }, 1000);

    let map_plot;
    map_plot = this.map1;
    this._dispatcherHomeService
      .livePath({
        bid: item.bookingId
      })
      .subscribe(
        (res: any) => {
          console.log('pathshowing', res);
          let stops = 0;
          if (res.data['6'] != undefined) {
            stops = stops + res.data['6'].length;
          }
          if (res.data['7'] != undefined) {
            stops = stops + res.data['7'].length;
          }
          if (res.data['8'] != undefined) {
            stops = stops + res.data['8'].length;
          }
          if (res.data['9'] != undefined) {
            stops = stops + res.data['9'].length;
          }
          if (res.data['16'] != undefined) {
            stops = stops + res.data['16'].length;
          }
          if (stops > 0) {
            const bounds = new google.maps.LatLngBounds();
            const infowindow = new google.maps.InfoWindow();
            if (res.data['6'] != undefined) {
              let icn;
              for (let inst = 0; inst < res.data['6'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['6'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Driver on the way';

                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  ((marker, content, infowindow) => {
                    return () => {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );

                google.maps.event.addListener(
                  marker,
                  'mouseleave',
                  ((marker, content, infowindow) => {
                    return () => {
                      infowindow.close();
                    };
                  })(marker, content, infowindow)
                );

                this.path_his.push(marker);
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['7'] != undefined) {
              let icn;
              for (let inst = 0; inst < res.data['7'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn2;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['7'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Driver reached to pickup address';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(this.map1, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['9'] != undefined) {
              let icn;
              for (let inst = 0; inst < res.data['9'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn3;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['9'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Loaded and trip started';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                icn = myGlobals.pathicn;
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['10'] != undefined) {
              let icn;
              for (let inst = 0; inst < res.data['10'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn4;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['10'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Reached to drop location';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                icn = myGlobals.pathicn;
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['11'] != undefined) {
              let icn;
              for (let inst = 0; inst < res.data['11'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn5;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['11'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Unloaded';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                icn = myGlobals.pathicn;
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            if (res.data['12'] != undefined) {
              let icn;
              for (let inst = 0; inst < res.data['12'].length; inst++) {
                if (inst == 0) {
                  icn = myGlobals.start_icn6;
                } else {
                  icn = myGlobals.pathicn;
                }
                const latlong = res.data['12'][inst].split(',');
                const latlongobj = {
                  lat: parseFloat(latlong[0]),
                  lng: parseFloat(latlong[1])
                };
                this.allpath_markers.push(latlongobj);
                const pos1 = new google.maps.LatLng(
                  parseFloat(latlong[0]),
                  parseFloat(latlong[1])
                );
                const marker = new google.maps.Marker({
                  position: pos1,
                  icon: icn,
                  map: map_plot
                });
                const content = 'Booking Completed';
                google.maps.event.addListener(
                  marker,
                  'mouseover',
                  (function (marker, content, infowindow) {
                    return function () {
                      infowindow.setContent(content);
                      infowindow.open(map_plot, marker);
                    };
                  })(marker, content, infowindow)
                );
                this.path_his.push(marker);
                icn = myGlobals.pathicn;
                bounds.extend(marker.position);
                map_plot.fitBounds(bounds);
              }
            }
            console.log('this.path_his', this.path_his);
            const lineSymbol = {
              path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
            };
            this.pathline = new google.maps.Polyline({
              path: this.allpath_markers,
              strokeOpacity: 0.8,
              strokeWeight: 2,
              strokeColor: '#4eff04',
              icons: [
                {
                  icon: lineSymbol,
                  repeat: '300px',
                  strokeColor: 'red',
                  offset: '100%'
                }
              ],
              map: map_plot
            });
            if (item.bookingStatus != 12) {
              this.mqttsubscribe(item, res.data);
            }

            // Polyline properties are defined below
            // var lineOptions = {
            //     path: this.allpath_markers,
            //    icons: [{
            //        icon: lineSymbol,
            //        repeat: '300px',
            //         strokeColor: 'red',
            //      offset: '100%'
            //   }],
            //     strokeWeight: 3,
            //     strokeColor: '#000000',
            //     strokeOpacity: 0.8
            // }

            // var polyline = new google.maps.Polyline(lineOptions);
            // polyline.setMap(this.map1);
            // var counter = 0;
            // var accessVar = window.setInterval(function() {
            //     counter = (counter + 1) % 350;

            //     var arrows = polyline.get('icons');
            //     arrows[0].offset = (counter / 2) + '%';
            //     polyline.set('icons', arrows);
            // }, 50);

            console.log('bounds', bounds);
            //this.map1.setCenter(bounds.getCenter(), this.map1.getBoundsZoomLevel(bounds));
            // this.map1.setZoom(2);
            console.log(this.map1.getZoom());
          } else {
            this.showgooglepath();
          }
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode);
        }
      );
  }

  expireBooking(data) {
    // console.log(this.offers, this.assigned_jobs, this.past_jobs);
    $('#' + data.bookingId).addClass('remove');
    if (this.showbooking_content != undefined) {
      if (this.showbooking_content.bookingId == data.bookingId) {
        this.showbooking_content = '';
        this.passDetailsContent = '';
        this.new_negotiations = [];
        this.old_negotiations = [];
        this.negotiations = [];
        this.getBookingDetails();
      }
    }
    setTimeout(() => {
      const indexofBooking = this.offers.findIndex(
        i => i.bookingId === data.bookingId
      );
      this.offers[indexofBooking].bookingStatus = 13;
      this.offers[indexofBooking].bookingStatusText = 'Booking Expired';
      this.past_jobs.splice(0, 0, this.offers[indexofBooking]);
      this.offers.splice(indexofBooking, 1);
      // this.unassignedCount--;
      // this.pastCount++;
      this.bookingCount();
    }, 1000);
  }
  // THIS FUNCTION WILL PASS THE DETAILS TO RIGHT HAND SLIDER AND DETAILS POUPUP AND SHOWS ROUTE MAP...............

  showgooglepath() {
    const pos1 = new google.maps.LatLng(
      this.passDetailsContent.pickup_lt,
      this.passDetailsContent.pickup_lg
    );
    const pos2 = new google.maps.LatLng(
      this.passDetailsContent.drop_lt,
      this.passDetailsContent.drop_lg
    );
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
    const marker2 = new google.maps.Marker({
      position: pos2,
      icon: myGlobals.dropupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker2);
    const directionsService2 = new google.maps.DirectionsService({
      preserveViewport: true
    });
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: { strokeColor: '#00ff5b' }
    });
    this.directionsDisplay.setMap(this.map1);
    const request = {
      origin: pos1, // LatLng|string
      destination: pos2, // LatLng|string
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    };
    directionsService2.route(request, (response, status) => {
      if (status === 'OK') {
        console.log(response);
        const point = response.routes[0].legs[0];
        let journey_time = point.distance.value;
        journey_time = journey_time / 1000;
        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(
          this.map1,
          'bounds_changed',
          event => {
            if (journey_time <= 100) {
              this.map1.setZoom(12);
            } else if (journey_time > 100 && journey_time < 500) {
              this.map1.setZoom(8);
            } else if (journey_time > 500 && journey_time < 1500) {
              this.map1.setZoom(6);
            } else if (journey_time > 1500 && journey_time < 1000) {
              this.map1.setZoom(5);
            } else if (journey_time < 1000) {
              this.map1.setZoom(3);
            }
            google.maps.event.trigger(this.map1, 'resize');
          }
        );
        setTimeout(function () {
          google.maps.event.removeListener(zoomChangeBoundsListener);
        }, 1000);
        this.directionsDisplay.setDirections(response);
      }
    });
  }
  passDetails(i: number, jobid: number, item) {
    // VARIABLES COME FROM ONCLICK FUNCTION FROM THIS COMPONENT.HTML
    this.show_drivers = false;
    $('#body_' + jobid).removeClass('blink');
    $('#job_details_button').trigger('click');
    $('#right_back_div').hide();
    const that = this;
    // $("#right_back_div").hide();
    // for(var key in this.drivers_list){
    //        that.map.removeLayer(this.drivers_list[key]); // DELETES DRIVERS WHICH DISPLAYED ON LOAD MAP MARKERS
    // }
    console.log(this.allroute_markers, 'asdfsadfmapmarkers');
    if (this.allroute_markers.length > 0) {
      for (let inst = 0; inst < this.allroute_markers.length; inst++) {
        this.allroute_markers[inst].setMap(null);
      }
      this.allroute_markers = [];
      //   this.directionsDisplay.setMap(null);
    }
    if (this.showingVehicleMarker != undefined) {
      this.showingVehicleMarker.setMap(null);
    }
    if (this.pathline != undefined) {
      this.pathline.setMap(null);
    }
    if (this.directionsDisplay != undefined) {
      this.directionsDisplay.setMap(null);
    }
    if (this.path_his.length > 0) {
      for (let inst = 0; inst < this.path_his.length; inst++) {
        this.path_his[inst].setMap(null);
      }
    }
    if (jobid == 3) {
      this.passDetailsContent = this.data3[i]; // PASSING COMPLETED TASKS DETAILS TO PASS DETAILS CONTENT
    } else if (jobid == 2) {
      this.passDetailsContent = this.data2[i]; // PASSING ASSIGNED TASKS DETAILS TO PASS DETAILS CONTENT  // BASED ON ID GOT FROM CLICK FUNCTION
    } else if (jobid == 1) {
      this.passDetailsContent = this.data1[i]; // PASSING UNASSIGNED TASKS DETAILS TO PASS DETAILS CONTENT
      this.showgooglepath();
    }
    $('.left_window_body .myoffer_blocks').removeClass('active');
    $('#body_' + this.passDetailsContent.bid).addClass('active');
    if (jobid == 2 || jobid == 3) {
      if (
        this.passDetailsContent.shipemntDetails[0].status == 11 ||
        this.passDetailsContent.shipemntDetails[0].status == 4 ||
        this.passDetailsContent.status == 3
      ) {
        this.showgooglepath();
      } else {
        if (this.passDetailsContent.shipemntDetails[0].status != 10) {
          for (
            let inst = 0;
            inst < this.changing_location_data.length;
            inst++
          ) {
            if (
              this.passDetailsContent.bid ==
              this.changing_location_data[inst].bid
            ) {
              this.passDetailsContent.driverDetails.Device_type_ = this.changing_location_data[
                inst
              ].Device_type_;
              this.passDetailsContent.driverDetails.battery_Per = this.changing_location_data[
                inst
              ].battery_Per;
              this.passDetailsContent.driverDetails.app_version = this.changing_location_data[
                inst
              ].app_version;
              this.passDetailsContent.driverDetails.DriversLatLongs =
                this.changing_location_data[inst].lt +
                ',' +
                this.changing_location_data[inst].lg;
              this.passDetailsContent.driverDetails.location_check = this.changing_location_data[
                inst
              ].location_check;
              this.passDetailsContent.statusCode = this.changing_location_data[
                inst
              ].st;
              break;
            }
          }
          const splitted_content = this.passDetailsContent.driverDetails
            .DriversLatLongs;
          const lat = splitted_content.split(',');
          const pos3 = new google.maps.LatLng(lat[0], lat[1]);
          this.current_driver_marker = new google.maps.Marker({
            position: pos3,
            // icon: myGlobals.vehicleicn,
            icon: {
              url: myGlobals.vehicleicn, // url
              scaledSize: new google.maps.Size(70, 70)
            },
            map: this.map1
          });
          this.allroute_markers.push(this.current_driver_marker);
          this.current_driver.Device_type_ = this.passDetailsContent.driverDetails.Device_type_;
          this.current_driver.a = this.passDetailsContent.driverDetails.battery_Per;
          this.current_driver.app_version = this.passDetailsContent.driverDetails.app_version;
          this.current_driver.battery_Per = parseFloat(
            this.passDetailsContent.driverDetails.battery_Per
          ).toFixed(0);
          this.current_driver.bid = this.passDetailsContent.bid;
          this.current_driver.lg = lat[0];
          this.current_driver.lt = lat[1];
          this.current_driver.location_check = this.passDetailsContent.driverDetails.location_check;
          this.current_driver.st = this.passDetailsContent.statusCode;
          this.show_drivers = true;

          console.log('this.passDetailsContent', this.passDetailsContent);
          this.changing_location_status = this.passDetailsContent.statusCode;
          this.live_path_show(this.passDetailsContent);
        } else {
          this.live_path_show(this.passDetailsContent); // completed bookings show only route path with out driver icon
        }
      }
    }
  }

  cancelBasedOnStatus() {
    if (this.showbooking_content.bookingStatus == 1) {
      this.cancelappt();
    } else {
      this.cancelApptAfterAccept();
    }
  }

  // cancel booking after accepting

  cancelApptAfterAccept() {
    const reason = $('input[name="quality"]:checked').val();
    this._dispatcherHomeService
      .cancelserviceAfterAccept({
        reason: reason,
        bookingId: this.cancellation_bid
          ? this.cancellation_bid.toString()
          : this.showbooking_content.bookingId.toString()
      })
      .subscribe(
        (res: any) => {
          $('#appcancel_rs').modal('hide');
          swal(this.languageTexts.swalTexts['bookingCancelled'], this.languageTexts.swalTexts['bookingCancelled'], 'success');
          $('#details_task').modal('hide');
          this.moveToPastAssigned();
          this.passDetailsContent = '';
          this.showbooking_content = '';
          this.bookingCount();
          // this.getmyjobs(2);
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode);
        }
      );
  }

  // cancel booking before accepting

  cancelappt() {
    const reason = $('input[name="quality"]:checked').val();
    console.log(
      'this.cancellation_bid ',
      this.cancellation_bid,
      this.showbooking_content.bookingId
    );
    this._dispatcherHomeService
      .cancelservice({
        reason: reason,
        bookingId: this.cancellation_bid
          ? this.cancellation_bid.toString()
          : this.showbooking_content.bookingId.toString()
      })
      .subscribe(
        (res: any) => {
          $('#appcancel_rs').modal('hide');
          swal(this.languageTexts.swalTexts['bookingCancelled'], this.languageTexts.swalTexts['bookingCancelled'], 'success');
          $('#details_task').modal('hide');
          this.moveToPast();
          this.cancellation_bid = this.showbooking_content.bookingId;
          this.passDetailsContent = '';
          this.showbooking_content = '';
          this.negotiations = [];
          this.old_negotiations = [];
          this.new_negotiations = [];
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode);
        }
      );
  }

  // move to past from offers

  moveToPast() {
    this.bookingCount();
    $('#body_' + this.cancellation_bid).addClass('remove');
    console.log(this.cancellation_bid);
    const indexofBooking = this.offers.findIndex(
      i => i.bookingId === this.cancellation_bid
    );
    console.log('indexofBooking', indexofBooking);
    if (indexofBooking != -1) {
      this.offers[indexofBooking].bookingStatus = 3;
      this.offers[indexofBooking].bookingStatusText = 'Request Cancelled';
      this.offers[indexofBooking].timeStamp.cancelled = moment().format(
        'Do MMMM YYYY, h:mm:ss a'
      );
      this.past_jobs.splice(0, 0, this.offers[indexofBooking]);
    } else {
      // find booking in assigned jobs
    }
    this.offers.splice(indexofBooking, 1);
  }

  // move to past from assinged
  moveToPastAssigned() {
    $('#body_' + this.cancellation_bid).addClass('remove');
    console.log(this.cancellation_bid);
    const indexofBooking = this.assigned_jobs.findIndex(
      i => i.bookingId === this.cancellation_bid
    );
    console.log('indexofBooking', indexofBooking);
    if (indexofBooking != -1) {
      this.assigned_jobs[indexofBooking].bookingStatus = 3;
      this.assigned_jobs[indexofBooking].bookingStatusText =
        'Request Cancelled';
      this.assigned_jobs[indexofBooking].timeStamp.cancelled = moment().format(
        'MMMM Do YYYY, h:mm:ss a'
      );
      this.past_jobs.splice(0, 0, this.assigned_jobs[indexofBooking]);
      // this.assignedCount--;
      // this.pastCount++;
    } else {
      // find booking in assigned jobs
    }
    this.assigned_jobs.splice(indexofBooking, 1);
  }

  show_pickup(item) {
    this.clearallpassdetails();
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    const pos1 = new google.maps.LatLng(
      item.pickup.location.latitude,
      item.pickup.location.longitude
    );
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
  }

  show_negos_on_map(item) {
    console.log(item);
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    const markerIcon = {
      url: 'https://s3.amazonaws.com/uberfortruck/driver_bid_marker.svg',
      scaledSize: new google.maps.Size(60, 80),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(32, 65),
      labelOrigin: new google.maps.Point(30, 36)
    };
    const bounds_ = new google.maps.LatLngBounds();
    for (let inst = 0; inst < item.length; inst++) {
      const lat = item[inst].latLong.split(',');
      const position = new google.maps.LatLng(
        parseFloat(lat[0]),
        parseFloat(lat[1])
      );
      const markerLabel = item[inst].mPrice.toString();
      const marker = new google.maps.Marker({
        position: position,
        icon: markerIcon,
        map: this.map1,
        label: {
          text: markerLabel,
          color: '#fff',
          fontSize: '13px',
          fontWeight: 'bold'
        }
      });
      bounds_.extend(position);
      this.map1.fitBounds(bounds_);
      this.allroute_markers.push(marker);
    }
  }

  google_path(item) {
    this.clearallpassdetails();
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    const pos1 = new google.maps.LatLng(
      item.pickup.location.latitude,
      item.pickup.location.longitude
    );
    const pos2 = new google.maps.LatLng(
      item.drop.location.latitude,
      item.drop.location.longitude
    );
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
    const marker2 = new google.maps.Marker({
      position: pos2,
      icon: myGlobals.dropupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker2);
    const directionsService2 = new google.maps.DirectionsService({
      preserveViewport: true
    });
    this.directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: { strokeColor: '#00ff5b' }
    });
    this.directionsDisplay.setMap(this.map1);
    const request = {
      origin: pos1, // LatLng|string
      destination: pos2, // LatLng|string
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    };

    directionsService2.route(request, (response, status) => {
      if (status === 'OK') {
        console.log(response);
        const point = response.routes[0].legs[0];
        let journey_time = point.distance.value;
        journey_time = journey_time / 1000;
        const zoomChangeBoundsListener = google.maps.event.addListenerOnce(
          this.map1,
          'bounds_changed',
          event => {
            if (journey_time <= 100) {
              this.map1.setZoom(12);
            } else if (journey_time > 100 && journey_time < 500) {
              this.map1.setZoom(8);
            } else if (journey_time > 500 && journey_time < 1500) {
              this.map1.setZoom(6);
            } else if (journey_time > 1500 && journey_time < 1000) {
              this.map1.setZoom(5);
            } else if (journey_time < 1000) {
              this.map1.setZoom(3);
            }
            google.maps.event.trigger(this.map1, 'resize');
          }
        );
        setTimeout(() => {
          google.maps.event.removeListener(zoomChangeBoundsListener);
        }, 1000);

        this.directionsDisplay.setDirections(response);
      }
    });
  }

  counter_offer(item) {
    jQuery('#counterPrice').on('keypress', function () {
      const value = parseInt($(this).val());
      console.log(value);
      if (value <= 0) {
        $('#counterPriceYes').attr('disabled', true);
      } else {
        $('#counterPriceYes').attr('disabled', false);
      }
    });
    if (item._id == undefined) {
      item._id = item.id;
    }
    this.current_bid_item = item;
    console.log('item.dispatcherId', item);
    this.dispatcherId = item.dispatcherId;
    setTimeout(() => {
      $('#counter_popup').modal('show');
    }, 100);
  }

  call_counter_offer() {
    const biddingPrice = this.counter_price;
    $('#body_' + this.negotiation_bid).removeClass('blink');
    console.log('this.dispatcherId', this.dispatcherId);
    this.map_loader = true;
    if (this.counter_price > 0) {
      this._dispatcherHomeService
        .counter_price({
          bookingId: this.negotiation_bid.toString(),
          driverId: this.current_bid_item.driverId,
          price: this.counter_price,
          status: 2,
          dispatcherId: this.dispatcherId
        })
        .subscribe(
          (res: any) => {
            console.log('response', res);
            $('#counter_popup').modal('hide');
            this.change_biding_status();
            this.map_loader = false;
            const biddingData = {
              bookingId: this.negotiation_bid.toString(),
              offerPrice: biddingPrice
            };
            console.log(this.counter_price);
            this.changeCustomerOffer(biddingData);
            this.counter_price = '';
            swal(
              this.languageTexts.swalTexts['counterSuccess'],
              this.languageTexts.swalTexts['counterSent'],
              'success'
            );
          },
          err => {
            this.map_loader = false;
            const error = err.error;
            const listErr = error.statusCode;
            console.log(error.statusCode);
            this.handleStatus(error.statusCode);
          }
        );
    } else {
      this.map_loader = false;
      swal('Warning', this.languageTexts.swalTexts['validCounter'], 'warning');
    }
  }

  accept_offer(item) {
    $('#accept_popup').modal('show');
    this.accept_offer_details = item;
    this.dispatcherId = item.dispatcherId;
    console.log('acceptoffer', item);
  }

  change_biding_status() {
    if (this.showbooking_content.bookingId == this.negotiation_bid) {
      const index_newnegos = this.new_negotiations.findIndex(
        i => i.driverId === this.current_bid_item.driverId
      );
      const index_negos = this.negotiations.findIndex(
        i => i.driverId === this.current_bid_item.driverId
      );
      this.new_negotiations[index_newnegos].status = 103;
      this.new_negotiations[
        index_newnegos
      ].offerPriceCustomer = this.counter_price;
      console.log(this.negotiations);
      this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
      this.old_negotiations.push(this.new_negotiations[index_newnegos]);
      this.new_negotiations.splice(index_newnegos, 1);
      this.counter_price = '';
    }
  }

  change_biding_to_past() {
    console.log(this.accept_offer_details);
    if (this.showbooking_content.bookindId == this.negotiation_bid) {
      const index_newnegos = this.new_negotiations.findIndex(
        i => i.bookindId === this.accept_offer_details['bookingId']
      );
      const index_negos = this.negotiations.findIndex(
        i => i._id === this.accept_offer_details._id
      );
      this.new_negotiations[index_newnegos].status = 104;
      this.new_negotiations[index_newnegos].aPrice = this.new_negotiations[
        index_newnegos
      ].mPrice;
      this.negotiations[index_negos] = this.new_negotiations[index_newnegos];
      this.old_negotiations.push(this.new_negotiations[index_newnegos]);
      this.new_negotiations.splice(index_newnegos, 1);
    }
  }
  get_negotitations(item, num) {
    this.old_negotiations = [];
    this.new_negotiations = [];
    this.negotiations = [];
    this.negos_loader = true;
    console.log(item);
    this._dispatcherHomeService
      .negotiations({
        bookingId: item.bookingId,
        status: num
      })
      .subscribe(
        (res: any) => {
          this.negotiation_bid = item.bookingId.toString();
          console.log('response---------->', res);
          for (
            let inst = 0;
            inst < res.dataForDispatcher.negotiation.length;
            inst++
          ) {
            // res.data[inst].time =  moment.unix(res.data[inst].time/1000).format("MMM Do YYYY, h:mm:ss a");
            // res.data[inst].time = moment.utc(res.data[inst].time).fromNow();
            if (
              res.dataForDispatcher.negotiation[inst].status == 101 ||
              res.dataForDispatcher.negotiation[inst].status == 102
            ) {
              this.new_negotiations.push(
                res.dataForDispatcher.negotiation[inst]
              );
            } else {
              this.old_negotiations.push(
                res.dataForDispatcher.negotiation[inst]
              );
            }
            this.negotiations.push(res.dataForDispatcher.negotiation[inst]);
            // this.showBiddingDriverMarkers(); // show driver dlatlongs
            // this.show_negos_on_map(this.negotiations);
          }
          console.log('response', res);
          this.negos_loader = false;
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode);
        }
      );
  }

  showBiddingDriverMarkers(item) {
    this.clearallpassdetails();
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    const pos1 = new google.maps.LatLng(
      item.pickup.location.latitude,
      item.pickup.location.longitude
    );
    const pos2 = new google.maps.LatLng(
      item.drop.location.latitude,
      item.drop.location.longitude
    );
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
  }
  // show booking details including path and details in right hand slide

  bookingrequested(item) {
    const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      'rotate_pointer'
    );
    $('.right-window').css('right', '0px');
    // if (isRightMarkerIsOpen) {
    //   jQuery('.right_marker').trigger('click');
    // }
    $('.left_window_body .myoffer_blocks ').removeClass('active'); // highlight active bid blcok
    $('#body_' + item.bookingId).addClass('active');
    console.log('passingContent', item);
    if (item.bookingStatus == 1 && item.negotiation.length == 0) {
      this.google_path(item);
      this.map_loader = true; // loader on
      this.showbooking_content = item; // sending component details
      const bid = item.bookingId;

      $('#right_back_div').hide(); // remove all the right hand side blocks
      $('#right_front_div').show();
      console.log('------------>', item.negotiation);
    } else {
      // remove all the markers if defined
      this.show_pickup(item);
      // highlight active bid blcok
      const bid = item.bookingId;
      $('#body_' + bid).removeClass('blink');
      this.get_negotitations(item, 3);
      this.showbooking_content = item;
      $('#right_back_div').show();
      $('#right_front_div').hide();
      this.shownegos_content = item;
    }
  }
  // assigned booking
  assingedBooking(item) {
    console.log(item);
    this.otp_entered = '';
    const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      'rotate_pointer'
    );
    console.log('isRightMarkerIsOpen', isRightMarkerIsOpen);
    $('.right-window').css('right', '0px');
    // if (!isRightMarkerIsOpen) {
    //   jQuery('.right_marker').trigger('click');
    // }
    // else {
    //   jQuery('.right_marker span').removeClass(
    //     'rotate_pointer'
    //   );
    //   jQuery('.right_marker span').addClass(
    //     'rotate_pointer'
    //   );
    //   jQuery('.right_marker').trigger('click');
    // }
    $('#body_' + item.bookingId).removeClass('blink');
    $('.left_window_body .myoffer_blocks ').removeClass('active'); // highlight active bid blcok
    $('#body_' + item.bookingId).addClass('active');
    if (
      item.bookingStatus != 4 &&
      item.bookingStatus != 3 &&
      item.bookingStatus != 13
    ) {
      this.live_path_show(item);
    }
    this.show_live_path(item);
    this.showbooking_content = item;
    this.otp_entered = '';
    // item.bookingStatus == 7 ? $('#otp_popup').modal('show') : '';
    // $('#right_front_div').show();
    // $('#right_back_div').hide();
  }
  show_live_path(item) {
    this.map_loader = true;
    this.clearallpassdetails();
    setTimeout(() => {
      this.map_loader = false;
    }, 1000);
    const pos1 = new google.maps.LatLng(item.pickupLat, item.pickupLong);
    const pos2 = new google.maps.LatLng(item.dropLat, item.dropLong);
    const marker = new google.maps.Marker({
      position: pos1,
      icon: myGlobals.pickupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker);
    const marker2 = new google.maps.Marker({
      position: pos2,
      icon: myGlobals.dropupicn,
      map: this.map1
    });
    this.allroute_markers.push(marker2);
  }
  old_negos_div_show() {
    jQuery('.connections_div_all').hide();
    jQuery('#offline_drivers_div').show();
    jQuery('.negotiations_header_blocks').removeClass('active');
    jQuery('#offline_dri_head').addClass('active');
  }

  total_negos_div_show() {
    jQuery('.connections_div_all').hide();
    jQuery('#total_drivers_div').show();
    jQuery('.negotiations_header_blocks').removeClass('active');
    jQuery('#total_dri_head').addClass('active');
  }

  new_negos_div_show() {
    jQuery('.connections_div_all').hide();
    jQuery('#online_drivers_div').show();
    jQuery('.negotiations_header_blocks').removeClass('active');
    jQuery('#online_dri_head').addClass('active');
  }

  show_history(item) {
    if ($('.myoffer_blocks').hasClass('blink')) {
      $('.myoffer_blocks').removeClass('blink');
    }
    this.negos_history = [];
    console.log(
      'historyItem',
      item,
      this.showbooking_content,
      this.new_negotiations
    );
    // $(".chat_history_block").hide();
    for (let inst = 0; inst < item.history.length; inst++) {
      item.history[inst].timeformat = moment
        .unix(item.history[inst].time)
        .format('DD MMM  YYYY, hh : mm a');
      this.negos_history.push(item.history[inst]);
    }
    if (
      !$(
        '#' +
        item.driverId +
        '_' +
        this.showbooking_content.bookingId +
        '_' +
        item.status
      ).hasClass('active')
    ) {
      $('.chat_history_block').removeClass('active');
      $(
        '#' +
        item.driverId +
        '_' +
        +this.showbooking_content.bookingId +
        '_' +
        item.status
      ).addClass('active');
      $(
        '#' +
        item.driverId +
        '_' +
        +this.showbooking_content.bookingId +
        '_' +
        item.status
      ).slideToggle();
    } else {
      $('.chat_history_block').removeClass('active');
      $(
        '#' +
        item.driverId +
        '_' +
        +this.showbooking_content.bookingId +
        '_' +
        item.status
      ).slideToggle();
    }
  }

  accept_negotiation() {
    $('#body_' + this.negotiation_bid).removeClass('blink');
    this.map_loader = true;
    // if(this.accept_offer_details.driverId == undefined || this.accept_offer_details.driverId == '') {
    //   this.accept_offer_details.driverId = '';
    // }
    // if(this.accept_offer_details.driverId == undefined || this.accept_offer_details.driverId == '') {
    //   this.accept_offer_details.driverId = '';
    // }
    console.log('this.accept_offer_details', this.accept_offer_details);
    console.log('this.driverId', this.accept_offer_details.driverId);
    console.log('this.dispatcherId', this.dispatcherId);
    this._dispatcherHomeService
      .accept_price({
        bookingId: this.negotiation_bid.toString(),
        driverId: this.accept_offer_details.driverId,
        status: 2,
        dispatcherId: this.dispatcherId
      })
      .subscribe(
        (res: any) => {
          this.map_loader = false;
          this.change_biding_to_past();
          console.log('response', res);
          swal(this.languageTexts.swalTexts['offerAccept'], '', 'success');
          // handshakedone =  0 is meant for no one accepted the job
          if (this.accept_offer_details['handShakeDone'] == 0) {
            const indexOfold = this.new_negotiations.findIndex(
              i => i.driverId === this.accept_offer_details.driverId
            );
            console.log(this.new_negotiations[indexOfold]);
            this.new_negotiations[indexOfold].status = 104;
            this.new_negotiations[indexOfold].time = this.languageTexts.swalTexts['fewAgo'];
            this.old_negotiations.push(this.new_negotiations[indexOfold]);
            this.new_negotiations.splice(indexOfold, 1);
          } else {
            // handshakedone =  1 is meant for some one accepted the job
            // commented out as Updating the booking via MQTT
            // this.change_booking_assigned(this.showbooking_content);
          }
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode);
        }
      );
  }
  changePosition(index, item) {
    // change the job position when driver counters
    console.log('index', index);
    console.log('item', item);
    const job = item;
    this.offers.splice(index, 1);
    this.offers.splice(0, 0, job);
  }
  getBookingDetails() {
    const isRightMarkerIsOpen = jQuery('.right_marker p').is(
      'rotate_pointer'
    );
    $(".right-window").toggleClass('open');
    // let open1 = $(".right-window").hasClass('open');
    // isRightMarkerIsOpen ? jQuery('.right_marker p').removeClass(
    //   'rotate_pointer'
    // ) : jQuery('.right_marker p').addClass(
    //   'rotate_pointer'
    // );
    // console.log('isRightMarkerIsOpen', isRightMarkerIsOpen, open1);
    // setTimeout(() => {
    //   if (!isRightMarkerIsOpen) {
    //     console.log('isRightMarkerIsOpen', isRightMarkerIsOpen);
    //     $('.right-window').css('right', '0px');
    //   }
    //   else {
    //     $('.right-window').css('right', '-300px');
    //   }
    // }, 1000);
  }
  driver_accepted(data) {
    if (data.bookingType == 1) {
      if (this.showbooking_content.bookingId == data.bookingId) {
        $('#details_task').modal('hide');
        this.getBookingDetails();
      }
      this.getmyjobs(1);
      this.getmyjobs(2);
      this.bookingCount();
      return;
    }

    // Find the job index to find the job
    const indexOfoldnegos = this.offers.findIndex(
      i => i.bookingId === data.bookingId
    );
    if (indexOfoldnegos !== -1) {
      if (this.offers[indexOfoldnegos].bookingType == 1) {
        this.getmyjobs(1);
        this.getmyjobs(2);
        this.bookingCount();
        return;
      }
    }
    this.changePosition(indexOfoldnegos, this.offers[indexOfoldnegos]);
    setTimeout(() => {
      $('#body_' + data.bookingId).addClass('blink');
    }, 100);
    console.log('this.showbooking_content', this.showbooking_content);
    if (indexOfoldnegos != -1) {
      if (this.showbooking_content != undefined) {
        if (this.showbooking_content.bookingId == data.bookingId) {
          // if the booking showing and booking id coming in reponse are same
          const indexOfold = this.old_negotiations.findIndex(
            i => i.driverId === data.negotiation.driverId
          );
          if (indexOfold != -1) {
            this.old_negotiations[indexOfold].offerPriceCustomer =
              data.negotiation.offerPriceCustomer;
            this.old_negotiations[indexOfold].offerPriceDriver =
              data.negotiation.offerPriceDriver;
            this.old_negotiations[indexOfold].status = data.negotiation.status;
            this.old_negotiations[indexOfold].time = 'a few seconds ago';
            this.old_negotiations[indexOfold].handShakeDone = 1;
            this.new_negotiations.push(this.old_negotiations[indexOfold]);
            this.old_negotiations.splice(indexOfold, 1);
            if (this.showbooking_content.negotiation == []) {
              this.old_negotiations[indexOfold].handShakeDone = 1;
              const indexofNewbooking = this.offers.findIndex(
                i => i.bookingId === data.bookingId
              );
              this.offers[indexofNewbooking].negotiation.push(
                this.old_negotiations[indexOfold]
              );
            }
          } else {
            // call single booking service to fetech vehilcle and driver details
            this.pushBidvalue(data);
            //this.new_negotiations.push(data.negotiation);
          }
        } else {
          // if the booking showing and reponse booking are different
          const indexOfold = this.offers.findIndex(
            i => i.bookingId === data.bookingId
          );
          if (this.offers[indexOfold].negotiation.length == 0) {
            this.offers[indexOfold].negotiationData.bestBidDriver =
              data.negotiation.offerPriceDriver;
            data.negotiation.handShakeDone = 1;
            this.offers[indexOfold].negotiation.push(data.negotiation);
          } else {
          }
        }
      } else {
        const indexOfold = this.offers.findIndex(
          i => i.bookingId === data.bookingId
        );
        if (this.offers[indexOfold].negotiation.length == 0) {
          data.negotiation.handShakeDone = 1;
          this.offers[indexOfold].negotiation.push(data.negotiation);
        }
        this.pushBidvalue(data);
      }
    } else {
      // call single booking api and push to offers array
    }
  }

  // pushBid value to show in the left side and change the no of offers on leftside
  pushBidvalue(data) {
    // get index of booking in offers array
    const indexOfBooking = this.offers.findIndex(
      i => i.bookingId === data.bookingId
    );
    // checks with current bestbid value if its 0 then push response value
    // else compare if its less change the best bid driver value
    if (this.offers[indexOfBooking].negotiationData.bestBidDriver != 0) {
      if (
        this.offers[indexOfBooking].negotiationData.bestBidDriver >
        data.negotiation.offerPriceDriver
      ) {
        this.offers[indexOfBooking].negotiationData.bestBidDriver =
          data.negotiation.offerPriceDriver;
      }
    } else {
      this.offers[indexOfBooking].negotiationData.bestBidDriver =
        data.negotiation.offerPriceDriver;
    }
    // checks if repsonse driver id in the negotiations array and change the value to show ->
    // no of offers on the leftside tab
    const indexofnegos = this.offers[indexOfBooking].negotiation.findIndex(
      i => i.driverId === data.negotiation.driverId
    );
    if (indexofnegos == -1) {
      this.offers[indexOfBooking].negotiation.push(data.negotiation);
    } else {
      // none of the booking ID is selected dont change the values in negorition array
    }
  }

  // changes best bid of the driver
  changeBestvalue(data) {
    // get index of booking in offers array
    const indexOfBooking = this.offers.findIndex(
      i => i.bookingId === data.bookingId
    );
    // checks with current bestbid value if its 0 then push response value
    // else compare if its less change the best bid driver value
    if (this.offers[indexOfBooking].negotiationData.bestBidDriver != 0) {
      if (
        this.offers[indexOfBooking].negotiationData.bestBidDriver >
        data.negotiation.offerPriceDriver
      ) {
        this.offers[indexOfBooking].negotiationData.bestBidDriver =
          data.negotiation.offerPriceDriver;
      }
    } else {
      this.offers[indexOfBooking].negotiationData.bestBidDriver =
        data.negotiation.offerPriceDriver;
    }
  }

  changeCustomerOffer(data) {
    console.log('data', data.bookingId);
    // get index of booking in offers array
    const indexOfBooking = this.offers.findIndex(
      i => i.bookingId == parseInt(data.bookingId)
    );
    console.log('data', indexOfBooking);
    console.log(
      'data',
      this.offers[indexOfBooking].negotiationData.bestBidCustomer
    );
    // checks with current bestbid value if its 0 then push response value
    // else compare if its less change the best bid driver value
    if (
      this.offers[indexOfBooking].negotiationData.bestBidCustomer <
      data.offerPrice
    ) {
      this.offers[indexOfBooking].negotiationData.bestBidCustomer =
        data.offerPrice;
    }
  }

  dispatcherId: any;
  driver_counter(data) {
    // triggers when drivers send a booking bid
    console.log('driver counter data', data);
    if (
      data.negotiation.dispatcherId != '' ||
      data.negotiation.dispatcherId != undefined
    ) {
      this.dispatcherId = data.negotiation.dispatcherId;
    }
    data.status = 1; // loop offers length to find the job
    const indexOfoldnegos = this.offers.findIndex(
      i => i.bookingId === data.bookingId
    );
    console.log(
      'this.showbooking_content',
      this.showbooking_content,
      this.old_negotiations
    );
    if (indexOfoldnegos != -1) {
      // if the bookingid from response in the offers array
      if (
        this.showbooking_content != undefined &&
        this.showbooking_content != ''
      ) {
        // if the booking is currently clicked or showing
        if (this.showbooking_content.bookingId == data.bookingId) {
          const indexOfold = this.old_negotiations.findIndex(
            i => i.driverId === data.negotiation.driverId
          );
          if (indexOfold != -1) {
            // booking is in view and change the negotiations past to new
            // change the value of last best driver bid
            this.changeBestvalue(data);
            this.old_negotiations[indexOfold].offerPriceCustomer =
              data.negotiation.offerPriceCustomer;
            this.old_negotiations[indexOfold].offerPriceDriver =
              data.negotiation.offerPriceDriver;
            this.old_negotiations[indexOfold].status = data.negotiation.status;
            this.old_negotiations[indexOfold].time = 'a few seconds ago';
            if (data.vehicle && data.vehicle != undefined) {
              this.old_negotiations[indexOfold].vehicleData.typeName =
                data.vehicle.typeName;
            }
            this.new_negotiations.push(this.old_negotiations[indexOfold]);
            this.old_negotiations.splice(indexOfold, 1);
          } else {
            // push new negotitaion in to an empty array or not found
            const indexOfBooking = this.offers.findIndex(
              i => i.bookingId === data.bookingId
            );
            this.changeBestvalue(data);
            this.offers[indexOfBooking].negotiation.push(data.negotiation);
          }
        } else {
          // some booking is in view but not the same which reponses comes
          // just push negotitaion and change the last bid value
          this.pushBidvalue(data);
        }
      } else {
        // none of the offers are selected and push the negoitation in to array change postion
        this.pushBidvalue(data);
      }
      this.changePosition(indexOfoldnegos, this.offers[indexOfoldnegos]);
      setTimeout(() => {
        $('#body_' + data.bookingId).addClass('blink');
      }, 100);
    } else {
      // call single booking service to get and push to offers array
    }
  }

  new_job(data) {
    // console.log("newhobs", data);
    this._dispatcherHomeService
      .negotiations({
        bookingId: data.bookingId,
        status: 3
      })
      .subscribe(
        (res: any) => {
          console.log('newBooking', res);
          // if (res.data.pickupDate != "0") {
          //   res.data.pickupDate = moment.unix(res.data.pickupDate).format("DD MMM  YYYY, hh mm ss a");
          // }
          // if (res.data.dropDate != "0") {
          //   res.data.dropDate = moment.unix(res.data.dropDate).format("DD MMM YYYY, hh mm a");
          // }
          // if (res.data.postedOn != "0") {
          //   res.data.postedOn = moment(res.data.postedOn).format("DD MMM YYYY, hh mm a");
          // }
          if (res.dataForDispatcher.bookingDateTimestamp != '0') {
            res.dataForDispatcher.bookingDateTimestamp = moment
              .unix(res.dataForDispatcher.bookingDateTimestamp)
              .format('DD MMM  YYYY, hh : mm a');
          }
          if (res.dataForDispatcher.deliveryDateTimestamp != '0') {
            res.dataForDispatcher.deliveryDateTimestamp = moment
              .unix(res.dataForDispatcher.deliveryDateTimestamp)
              .format('DD MMM YYYY, hh : mm a');
          }
          if (res.dataForDispatcher.timeStamp.created != '0') {
            res.dataForDispatcher.timeStamp.created = moment(
              res.dataForDispatcher.timeStamp.created * 1000
            ).format('DD MMM YYYY, hh : mm a');
          }
          if (res.dataForDispatcher.activities != undefined) {
            for (
              let bookingstatus = 0;
              bookingstatus < res.dataForDispatcher.activities.length;
              bookingstatus++
            ) {
              res.dataForDispatcher.activities[
                bookingstatus
              ].timeConverted = moment(
                res.dataForDispatcher.activities[bookingstatus].time
              ).format('DD MMM YYYY, hh : mm a');
            }
          }
          // this.unassignedCount++;
          this.offers.splice(0, 0, res.dataForDispatcher);
          this.showTimer(res.dataForDispatcher);
          setTimeout(function () {
            $('#body_' + res.dataForDispatcher.bookingId).addClass(
              'blink_finite'
            );
          }, 1000);
          this.getmyjobs(1);
          // this.getmyjobs(2);
          // this.getmyjobs(3);
          this.bookingCount();
        },
        err => {
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode);
        }
      );
  }

  change_booking_assigned(data) {
    if (data == undefined || data == '') {
      const bookingData = {
        bookingId: this.negotiation_bid
      };
      data = bookingData;
    }
    console.log('change_booking_assigned', data);
    $('#' + data.bookingId).addClass('remove');

    if (this.showbooking_content && this.showbooking_content.bookingId == data.bookingId) {
      // const isRightMarkerIsOpen = $('.right_marker span').hasClass(
      //   'rotate_pointer'
      // );
      // if (!isRightMarkerIsOpen) {
      //   $('.right_marker').trigger('click');
      // }
      setTimeout(() => {
        this.showbooking_content = [];
        this.old_negotiations = [];
        this.new_negotiations = [];
        this.negotiations = [];
        this.current_bid_item = undefined;
      }, 1000);
    }
    this.getmyjobs(1);
    this.getmyjobs(2);
    // this.getmyjobs(3);
    this.bookingCount();
    console.log('this.offers,', this.offers);
  }

  bookingCount() {
    this._dispatcherHomeService.getBookingCounter({}).subscribe(
      (res: any) => {
        console.log('counterNumbers--------------->', res);
        this.unassignedCount = res.data.unassigned;
        this.assignedCount = res.data.assigned;
        this.pastCount = res.data.past;
      },
      err => {
        const error = err.error;
        const listErr = error.statusCode;
        this.handleStatus(error.statusCode);
      }
    );
    $('.right-window').css('right', '-300px');
    $('.right-window').removeClass('open');
  }

  booknow() {
    $('.booking_buutns').trigger('click');
  }

  // rating popup
  comments: any;
  rating = 0;
  enableReviewSubmitButton = false;
  ratingcomments(val) {
    this._dispatcherHomeService.getratings({}).subscribe((res: any) => {
      this.rating = val;
      switch (val) {
        case 1:
          this.comments = res.data.rating1;
          break;
        case 2:
          this.comments = res.data.rating2;
          break;
        case 3:
          this.comments = res.data.rating3;
          break;
        case 4:
          this.comments = res.data.rating4;
          break;
        case 5:
          this.comments = res.data.rating5;
          break;
      }

      this.enableReviewSubmitButton = true;
    });
  }
  rating_text = [];
  high_rating = [];
  show_low_rating: Boolean = false;
  show_high_rating: any;
  driver_rating: any;
  show_raing_txt(rate) {
    $('input[name=selector_review]').val(
      $('input[name=selector_review] option:first').val()
    );
    this.high_rating = [];
    this.rating_text = [];
    this.show_low_rating = true;
    this.ratingcomments(rate);
    this.show_high_rating = false;
    for (const key in this.driver_rating) {
      if (key == rate) {
        this.rating_text = this.driver_rating[key];
        break;
      }
    }
  }

  // submit review and reting
  submitReivew() {
    // submit review
    if (this.rating == undefined) {
      swal('Warning', this.languageTexts.swalTexts['review'], 'warning');
      // this.comment_error = true;
    } else {
      const comment = $('#review_content').val();
      const review = $('input[name=cb]:checked').val();
      this.submitreview_call(comment, review);
    }
  }

  addhigh_reviews(text) {
    const indexofReview = this.high_rating.findIndex(i => i === text);
    if (indexofReview == -1) {
      this.high_rating.push(text);
    } else {
      this.high_rating.splice(indexofReview, 1);
    }
  }

  submitreview_call(comment, review) {
    $('.appt_loader_parent').show();
    // var bid = this.rating_b_details["bid"];
    if (this.rating == 0) {
      $('.appt_loader_parent').hide();
      swal('Warning', this.languageTexts.swalTexts['review'], 'warning');
    } else {
      const bid = this.pending_review[0].bookingId;
      this._dispatcherHomeService
        .postreview({
          bookingId: bid.toString(),
          rating: this.rating,
          review: this.high_rating.toString()
        })
        .subscribe((res: any) => {
          $('#review_popup').modal('hide');
          $('.appt_loader_parent').hide();
          this.rating = 0;
          this.high_rating = [];
          this.comments = [];
          this.enableReviewSubmitButton = false;
          this.pending_reviews();
        });
    }
    // this.rating = this.rating == 0 ? 5 : this.rating;
  }

  pendingDriverId: any;
  pending_review = [];
  driverId: any;
  pending_reviews() {
    this.pending_review = [];
    this._dispatcherHomeService.getpendingreviews({}).subscribe((res: any) => {
      console.log('pendingreviewsssssss--------------->', res);
      if (res.data.length > 0) {
        for (let inst = 0; inst < res.data.length; inst++) {
          // this.callsingalbooking(res.data[inst].bookingId);
          this.pending_review.push(res.data[inst]);
          this.pendingDriverId = res.data[inst].driver.id;
        }

        this.driverId = res.data[0].driver.id;
        setInterval(() => {
          $('#review_popup').modal({ backdrop: 'static', keyboard: false });
        }, 500);
        this.getfavdriver();
        // this.getCustomerBookings1(
        //   res.data[0].bookingId,
        //   res.data[0].bookingStatus,
        //   2
        // );
        //this.getCustomerBookings1(res.data[0].bookingId, res.data[0].bookingStatus, 2);

        // $('#review_popup').modal('show');
        // this.callsingalbooking(res.data[0].order_id);
      }
    });
  }

  changefilter(styleIndex, typeId = false) {
    // console.log(this.map1);
    if (typeId) {
      this.map1.setMapTypeId(google.maps.MapTypeId.SATELLITE);
    } else {
      this.map1.setMapTypeId(google.maps.MapTypeId.ROADMAP);
      this.map1.setOptions({ styles: mapStyle[styleIndex] });
    }
  }

  loadMap() {
    console.warn('loadMap', typeof google);
    if (typeof google === 'undefined') {
      setTimeout(() => {
        this.loadMap();
      }, 1500);
      return;
    }
    this.map1 = new google.maps.Map(document.getElementById('mapP'), {
      center: new google.maps.LatLng(12.9716, 77.5946),
      zoom: 13,
      minZoom: 1,
      styles: mapStyle[0],
      disableDefaultUI: true
    });

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(e => {
        const position_marker = new google.maps.LatLng(
          e.coords.latitude,
          e.coords.longitude
        );
        this.current_location_marker = new google.maps.Marker({
          position: position_marker,
          icon: myGlobals.currenticn,
          map: this.map1
        });
        this.allroute_markers.push(this.current_location_marker);
        this.map1.setCenter(position_marker);
        this.map1.setZoom(18);
      }, err => {
        console.log(err);
      });
    } else {
      let lat, lon;
      jQuery.get('https://ipapi.co/json/').always(res1 => {
        if (res1.status >= 400 || res1.error) {
          jQuery.get(
            'https://ipinfo.io',
            response => {
              lat = response.loc.split(',')[0];
              lon = response.loc.split(',')[1];
            },
            'jsonp'
          );
        } else {
          lat = res1.latitude;
          lon = res1.longitude;
        }
      });
      const position_marker = new google.maps.LatLng(lat, lon);
      this.current_location_marker = new google.maps.Marker({
        position: position_marker,
        icon: myGlobals.currenticn,
        map: this.map1
      });
      this.allroute_markers.push(this.current_location_marker);
      this.map1.setCenter(position_marker);
      this.map1.setZoom(18);
    }

    const controlDiv = document.getElementById('locateMeButton');
    controlDiv.addEventListener('click', () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            // console.log(position);
            const latlng = new google.maps.LatLng(
              position.coords.latitude,
              position.coords.longitude
            );
            this.current_location_marker.setPosition(latlng);
            this.map1.panTo(latlng);
            this.map1.setZoom(20);
          },
          err => {
            console.log(err);
            swal(
              'Warning',
              this.languageTexts.swalTexts['geoLocationErr'],
              'warning'
            );
          }
        );
      }
    });
  }

  ngOnInit() {
    toastr.options = {
      closeButton: true,
      debug: false,
      newestOnTop: true,
      progressBar: true,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      showDuration: '300',
      hideDuration: '1000',
      timeOut: '3000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut'
    };

    this.bookcomplete = this.languageService.bookingComplete;
    this.bookingCount();
    // this.getslaveappointments();
    this.getmyjobs(1);
    this.getmyjobs(2);
    this.getmyjobs(3);
    this.pending_reviews();
    this.currency = sessionStorage.getItem('currency');
    $('.booking_buutns').show();
    $('[data-toggle="tooltip"]').tooltip();
    // MAP STYLES FOR ALL FILTERS
    const styles = {
      default: [
        {
          featureType: 'all',
          elementType: 'all',
          stylers: [
            {
              invert_lightness: true
            },
            {
              saturation: 10
            },
            {
              lightness: 30
            },
            {
              gamma: 0.5
            },
            {
              hue: '#435158'
            }
          ]
        }
      ],
      silver: [
        {
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }]
        },
        {
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }]
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#f5f5f5' }]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#bdbdbd' }]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#dadada' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }]
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }]
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#c9c9c9' }]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }]
        }
      ],

      night: [
        { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
        {
          featureType: 'administrative.locality',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#d59563' }]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#d59563' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#263c3f' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#6b9a76' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#38414e' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#212a37' }]
        },
        {
          featureType: 'road',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9ca5b3' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#746855' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#1f2835' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#f3d19c' }]
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#2f3948' }]
        },
        {
          featureType: 'transit.station',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#d59563' }]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#17263c' }]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#515c6d' }]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#17263c' }]
        }
      ],

      retro: [
        { elementType: 'geometry', stylers: [{ color: '#ebe3cd' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#523735' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f1e6' }] },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#c9b2a6' }]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#dcd2be' }]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#ae9e90' }]
        },
        {
          featureType: 'landscape.natural',
          elementType: 'geometry',
          stylers: [{ color: '#dfd2ae' }]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#dfd2ae' }]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#93817c' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry.fill',
          stylers: [{ color: '#a5b076' }]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#447530' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#f5f1e6' }]
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [{ color: '#fdfcf8' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#f8c967' }]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#e9bc62' }]
        },
        {
          featureType: 'road.highway.controlled_access',
          elementType: 'geometry',
          stylers: [{ color: '#e98d58' }]
        },
        {
          featureType: 'road.highway.controlled_access',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#db8555' }]
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#806b63' }]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [{ color: '#dfd2ae' }]
        },
        {
          featureType: 'transit.line',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#8f7d77' }]
        },
        {
          featureType: 'transit.line',
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#ebe3cd' }]
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [{ color: '#dfd2ae' }]
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [{ color: '#b9d3c2' }]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#92998d' }]
        }
      ],

      hiding: [
        {
          featureType: 'poi.business',
          stylers: [{ visibility: 'off' }]
        },
        {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }]
        }
      ]
    };

    var style_common = [
      {
        featureType: 'all',
        elementType: 'all',
        stylers: [
          {
            invert_lightness: true
          },
          {
            saturation: 10
          },
          {
            lightness: 30
          },
          {
            gamma: 0.5
          },
          {
            hue: '#435158'
          }
        ]
      }
    ];

    var what = this; // INSTAILIZATIN OF MAP BASED ON CURRENT LOCATION
    setTimeout(() => {
      jQuery.get('https://ipapi.co/json/').always(res => {
        // console.warn(res);
        if (res.status >= 400 || res.error) {
          jQuery.get(
            'https://ipinfo.io',
            response => {
              this.onLoadLatitude = response.loc.split(',')[0];
              this.onLoadLongitude = response.loc.split(',')[1];
            },
            'jsonp'
          );
        } else {
          this.onLoadLatitude = res.latitude;
          this.onLoadLongitude = res.longitude;
        }
        var that = this;
        function addYourLocationButton(mapAr, marker) {
          // const controlDiv: any = document.createElement('div');
          const controlDiv: any = document.getElementById('locateMe');
          // controlDiv.setAttribute('id', 'locateMe');
          const firstChild = document.getElementById('locateMeButton');
          // firstChild.style.backgroundColor = '#fff';
          // firstChild.style.border = 'none';
          // firstChild.style.outline = 'none';
          // firstChild.style.width = '28px';
          // firstChild.style.height = '28px';
          // firstChild.style.borderRadius = '2px';
          // firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
          // firstChild.style.cursor = 'pointer';
          // firstChild.style.marginRight = '10px';
          // firstChild.style.padding = '0px';
          controlDiv.appendChild(firstChild);
          const secondChild = document.createElement('div');
          secondChild.style.margin = '5px';
          secondChild.style.width = '18px';
          secondChild.style.height = '18px';
          secondChild.style.backgroundImage =
            'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)';
          secondChild.style.backgroundSize = '180px 18px';
          secondChild.style.backgroundPosition = '0px 0px';
          secondChild.style.backgroundRepeat = 'no-repeat';
          secondChild.id = 'you_location_img';
          firstChild.appendChild(secondChild);
          google.maps.event.addListener(mapAr, 'dragend', function () {
            $('#you_location_img').css('background-position', '0px 0px');
          });
          firstChild.addEventListener('click', function () {
            let imgX = '0';
            const animationInterval = setInterval(function () {
              if (imgX == '-18') {
                imgX = '0';
              } else {
                imgX = '-18';
              }
              $('#you_location_img').css(
                'background-position',
                imgX + 'px 0px'
              );
            }, 500);
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function (position) {
                const latlng = new google.maps.LatLng(
                  // position.coords.latitude,
                  // position.coords.longitude
                  -28.4793, 24.6727
                );
                marker.setPosition(latlng);
                mapAr.setCenter(latlng);
                clearInterval(animationInterval);
                $('#you_location_img').css('background-position', '-144px 0px');
              });
            } else {
              clearInterval(animationInterval);
              $('#you_location_img').css('background-position', '0px 0px');
            }
          });
          // controlDiv.index = 1;
          // mapAr.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
        }
        // INITIALIZING MAP
        var map = new google.maps.Map(document.getElementById('mapP'), {
          center: new google.maps.LatLng(
            // this.onLoadLatitude,
            // this.onLoadLongitude
            -28.4793, 24.6727
          ),
          zoom: 5,
          minZoom: 1,
          styles: style_common,
          disableDefaultUI: true
        });

        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(e => {
            var position_marker = new google.maps.LatLng(
              // e.coords.latitude,
              // e.coords.longitude
              -28.4793, 24.6727
            );
            var infowindow = new google.maps.InfoWindow();
            this.current_location_marker = new google.maps.Marker({
              position: position_marker,
              icon: myGlobals.currenticn,
              map: map
            });
            addYourLocationButton(map, this.current_location_marker);
            this.allroute_markers.push(this.current_location_marker);
            map.setCenter(position_marker);
            map.setZoom(5);
          });
        } else {
          let lat, lon;
          jQuery.get('https://ipapi.co/json/').always(res1 => {
            if (res1.status >= 400 || res1.error) {
              jQuery.get(
                'https://ipinfo.io',
                response => {
                  lat = response.loc.split(',')[0];
                  lon = response.loc.split(',')[1];
                },
                'jsonp'
              );
            } else {
              lat = res1.latitude;
              lon = res1.longitude;
            }
          });
          const position_marker = new google.maps.LatLng(-28.4793, 24.6727);
          const infowindow = new google.maps.InfoWindow();
          this.current_location_marker = new google.maps.Marker({
            position: position_marker,
            icon: myGlobals.currenticn,
            map: map
          });
          this.allroute_markers.push(this.current_location_marker);
          map.setCenter(position_marker);
          map.setZoom(5);
          addYourLocationButton(map, this.current_location_marker);
        }
        this.map1 = map;
        var current_location;
        what.map1 = map;
        // GETTING GODSVIEW PROVIDERS LIST
        // MAP FILTER DROP DOWN
        var those = what;
        jQuery('.radio_buttons').click(function () {
          console.log("radio buttons")
          var that = this;
          if ($(this).val() != 'default') {
            that.map_layer = $(this).val();
            those.map1.setOptions({ styles: styles[that.map_layer] });
          } else {
            those.map1.setOptions({ styles: styles['default'] });
          }
        });
        what.map1.setOptions({
          minZoom: 2,
          maxZoom: 40
        });
      }); // END OF ---- INSTAILIZATIN OF MAP BASED ON CURRENT LOCATION
    }, 1000);
    const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      'rotate_pointer'
    );
    // if (!isRightMarkerIsOpen) {
    //   jQuery('.right_marker').trigger('click');
    // }
    $('#hidden_flipping').click(() => {
      var content = $('#hidden_flipping').text();
      var splitted_content = content.split(',');
      var bid = splitted_content[0];
      var status = splitted_content[1];
      $('#assigned_but').addClass('glow_text');
      this.assigned_full_count++;
      setTimeout(() => {
        $('#assigned_but').removeClass('glow_text');
      }, 5500);
      this._dispatcherHomeService
        .getsingalBooking({
          ent_page_index: '0',
          ent_booking_id: bid
        })
        .subscribe(
          res => {
            console.log('signalbooking', res);
            if (
              res['data'].appointments[0].shipemntDetails[0]
                .DriverLoadedStartedTime != undefined
            ) {
              if (res['data'].appointments[0].bookingDateTimestamp != '0') {
                res['data'].appointments[0].bookingDateTimestamp = moment
                  .unix(res['data'].appointments[0].bookingDateTimestamp)
                  .format('DD MMM  YYYY, hh : mm a');
              }
              if (res['data'].appointments[0].deliveryDateTimestamp != '0') {
                res['data'].appointments[0].deliveryDateTimestamp = moment
                  .unix(res['data'].appointments[0].deliveryDateTimestamp)
                  .format('DD MMM YYYY, hh : mm a');
              }
              if (res['data'].appointments[0].bookingTimeStamp != '0') {
                res['data'].appointments[0].booking_time = moment
                  .unix(res['data'].appointments[0].bookingTimeStamp)
                  .format('MMMM Do YYYY, h:mm:ss a');
              }
              if (
                res['data'].appointments[0].shipemntDetails[0]
                  .DriverLoadedStartedTime != '0'
              ) {
                res['data'].appointments[0].shipemntDetails[0].DriverLoadedStartedTime = moment
                  .unix(
                    res['data'].appointments[0].shipemntDetails[0]
                      .DriverLoadedStartedTime
                  )
                  .format('MMMM Do YYYY, h:mm:ss a');
              }
              if (
                res['data'].appointments[0].shipemntDetails[0]
                  .DriverAcceptedTime != '0'
              )
                res['data'].appointments[0].shipemntDetails[0].DriverAcceptedTime = moment
                  .unix(
                    res['data'].appointments[0].shipemntDetails[0]
                      .DriverAcceptedTime
                  )
                  .format('MMMM Do YYYY, h:mm:ss a');

              if (
                res['data'].appointments[0].shipemntDetails[0].DriverArrivedTime !=
                '0'
              )
                res['data'].appointments[0].shipemntDetails[0].DriverArrivedTime = moment
                  .unix(
                    res['data'].appointments[0].shipemntDetails[0]
                      .DriverArrivedTime
                  )
                  .format('MMMM Do YYYY, h:mm:ss a');

              if (
                res['data'].appointments[0].shipemntDetails[0]
                  .DriverCompletedTime != '0'
              )
                res['data'].appointments[0].shipemntDetails[0].DriverCompletedTime = moment
                  .unix(
                    res['data'].appointments[0].shipemntDetails[0]
                      .DriverCompletedTime
                  )
                  .format('MMMM Do YYYY, h:mm:ss a');

              if (
                res['data'].appointments[0].shipemntDetails[0]
                  .DriverReachedDropLocationTime != '0'
              )
                res['data'].appointments[0].shipemntDetails[0].DriverReachedDropLocationTime = moment
                  .unix(
                    res['data'].appointments[0].shipemntDetails[0]
                      .DriverReachedDropLocationTime
                  )
                  .format('MMMM Do YYYY, h:mm:ss a');

              if (
                res['data'].appointments[0].shipemntDetails[0].DriverDropedTime !=
                '0'
              )
                res['data'].appointments[0].shipemntDetails[0].DriverDropedTime = moment
                  .unix(
                    res['data'].appointments[0].shipemntDetails[0].DriverDropedTime
                  )
                  .format('MMMM Do YYYY, h:mm:ss a');
            }

            if (status == '6') {
              this.data1 = jQuery.grep(this.data1, value => {
                return value.bid != res['data'].appointments[0].bid;
              });
              this.data2.splice(0, 0, res['data'].appointments[0]);
            } else if (status == '10') {
              this.data2 = jQuery.grep(this.data2, value => {
                return value.bid != res['data'].appointments[0].bid;
              });
              this.data3.splice(0, 0, res['data'].appointments[0]);
            }
          },
          err => {
            var error = JSON.parse(err._body);
            var listErr = error.statusCode;
            this.handleStatus(error.statusCode);
          }
        );
    });
    $('#hidden_flipping_assign').click(() => {
      var content = $('#hidden_flipping_assign').text();
      var splitted_content = content.split(',');
      var bid = splitted_content[0];
      var status = splitted_content[1];
      var msg = splitted_content[2];
      var date_bid = splitted_content[3];
      for (var inst = 0; inst < this.data2.length; inst++) {
        if (this.data2[inst].bid == bid) {
          console.log(bid);
          console.log(this.data2[inst].bid);
          console.log(date_bid);
          this.data2[inst].shipemntDetails[0].status = status;
          this.data2[inst].status = msg;
          console.log(this.data2[inst]);
          console.log('before-bookingbidno', date_bid, this.data2[inst]);
          switch (status) {
            case '7':
              this.data2[inst].shipemntDetails[0].DriverArrivedTime = date_bid;
              break;
            case '8':
              this.data2[
                inst
              ].shipemntDetails[0].DriverLoadedStartedTime = date_bid;
              break;
            case '9':
              this.data2[
                inst
              ].shipemntDetails[0].DriverReachedDropLocationTime = date_bid;
              break;
            case '16':
              this.data2[inst].shipemntDetails[0].DriverDropedTime = date_bid;
              break;
          }
          console.log('bookingbidno', this.data2[inst]);
          break;
        }
      }
    });

    // $("#hidden_flipping").click(()=>{
    //   // this.data2.splice(0, 0, item);
    //   this.assigned_count--;
    //   $("#assigned_but").addClass('glow_text');
    //    this.assigned_full_count++;
    //    setTimeout(()=>{$("#assigned_but").removeClass('glow_text');}, 5500);
    //     this._dispatcherHomeService.getsingalBooking({
    //     "ent_page_index": "0",
    //     "ent_booking_id":$("#hidden_flipping").text(),
    //   }).subscribe((res) => {

    //       this.data2.splice(0, 0, res.data.appointments[0]);
    //                  this.data1 = jQuery.grep(this.data1, (value) => {
    //                       return value.bid != res.data.appointments[0].bid;
    //                   });
    //   });
    // });
    //   $("#hidden_flipping_assign").click(()=>{
    //     this._dispatcherHomeService.getsingalBooking({
    //     "ent_page_index": "0",
    //     "ent_booking_id":$("#hidden_flipping_assign").text(),
    //   }).subscribe((res) => {
    //          this.data1 = jQuery.grep(this.data1, (value) => {
    //                       return value.bid != res.data.appointments[0].bid;
    //                   });
    //       this.data2.splice(0, 0, res.data.appointments[0]);
    //    //$('#'+res.data.appointments[0].bid).trigger('click');
    //   });
    // });
    //   $("#hidden_flipping_completed").click(()=>{
    //     this._dispatcherHomeService.getsingalBooking({
    //     "ent_sess_token": localStorage.getItem('authToken'),
    //     "ent_dev_id":localStorage.getItem('devid'),
    //     "ent_appnt_dt": this.current_time_var,
    //     "ent_date_time": this.current_time_var,
    //     "ent_page_index": "0",
    //     "ent_booking_id":$("#hidden_flipping_completed").text(),
    //   }).subscribe((res) => {
    //                this.data2 = jQuery.grep(this.data2, (value) => {
    //                       return value.bid != res.data.appointments[0].bid;
    //                   });
    //     this.assigned_full_count--;
    //     this.completed_count++;
    //       this.data3.splice(0, 0, res.data.appointments[0]);

    //    //$('#'+res.data.appointments[0].bid).trigger('click');
    //   });
    // });

    $('#hidden_flipping_expired').click(() => {
      var bid = $('#hidden_flipping_expired').text();
      var splitted_content_det = bid.split(',');
      console.log('splitted_content_det', splitted_content_det);
      if (splitted_content_det[1] == '55') {
        this.data1 = jQuery.grep(this.data1, value => {
          if (value.bid == splitted_content_det[0]) {
            value.shipemntDetails[0].status = 11;
            value.status = 'Booking expired';
            console.log('value', value);
            this.data3.unshift(value);
          }
          return value.bid != splitted_content_det[0];
        });
      } else {
        this.data2 = jQuery.grep(this.data2, value => {
          if (value.bid == splitted_content_det[0]) {
            value.shipemntDetails[0].status = 3;
            value.status = 'You cancelled.';
            this.data3.unshift(value);
          }
          return value.bid != splitted_content_det[0];
        });
      }
      this.passDetailsContent = '';
    });

    $('#load_more').click(() => {
      this.page_index++;
    });
    $('#load_more').mouseover(function () {
      $('.more_tooltip').show();
    });
    $('#load_more').mouseout(function () {
      $('.more_tooltip').hide();
    });

    // DETAIL POPUP HIDE AND SHOW
    $('.details_description2').hide();
    $('.details_description3').hide();
    //FILTER TOOGLE ANIMATION

    $('#floating_button_body').hide();
    $('#floating_button').click(function () {
      console.log("value")
      $('#floating_button_body').toggle(function () {
        $('#floating_button_body').animate({
          height: 'auto'
        });
      });
    });

    // this.pubnub = PUBNUB({
    //             publish_key: "pub-c-9ad47306-ef0c-40a0-9f90-42e71a1e18fc",
    //             subscribe_key: "sub-c-b1aa3090-834f-11e6-974e-0619f8945a4f",
    //             ssl: false  //this is for https
    //         });
    //       this.pubnub.subscribe({
    //       channel: 'godzviewChn',
    //       message: (message) => {
    //         var current_time_stamp = moment().toDate().getTime();
    //         current_time_stamp = Math.round(current_time_stamp / 1000);
    //            for(var key in this.drivers_timings){
    //                   if(this.drivers_timings[key][3]==message.o2._id){
    //                               var messasge_status = message.o.$set.status;
    //                               var last_seen_time = message.o.$set.lastTs;
    //                               last_seen_time = ((last_seen_time + this.difference_of_timings)-current_time_stamp);
    //                               this.drivers_timings[key][0] = last_seen_time+"sec ago";
    //                                           if(messasge_status=="undefined"){
    //                                              console.log("undefined");
    //                                              }
    //                   else if(messasge_status==3||messasge_status==4){
    //                              this.drivers_timings[key][2]=message.o.$set.status;
    //                              if(this.driver_online_email==message.o2._id){
    //                              var last_seen_time = message.o.$set.lastTs;
    //                              last_seen_time = ((last_seen_time + this.difference_of_timings)-current_time_stamp);
    //                              this.driver_timing_singal = last_seen_time+"sec ago";
    //                              this.driver_online_offline = message.o.$set.status;
    //                              }
    //                              for(var key in this.drivers_list){                  // remove online drivers from map or adding new online drivers
    //                                               if(this.drivers_list[key]._id==message.o2._id){
    //                                                 // showing online , offline drivers based on this offline status code 4
    //                                                  if(message.o.$set.status==4){
    //                                                    $(this.drivers_list[key]._icon).removeClass('css-icon');
    //                                                     this.online_drivers = jQuery.grep(this.online_drivers,function(value){
    //                                                                return value._id != message.o2._id;
    //                                                       });
    //                                                       for(var key in this.total_drivers){
    //                                                       if(this.total_drivers[key]._id==message.o2._id){
    //                                                         this.total_drivers[key].status = 4;
    //                                                          this.offline_drivers.splice(1,0,this.total_drivers[key]);
    //                                                          break;
    //                                                     }
    //                                                   }
    //                                                   }

    //                                                   else{
    //                                                     $(this.drivers_list[key]._icon).addClass('css-icon');
    //                                                     for(var key in this.total_drivers){
    //                                                       if(this.total_drivers[key]._id==message.o2._id){
    //                                                         this.total_drivers[key].status = 3 ;
    //                                                          this.online_drivers.splice(1,0,this.total_drivers[key]);
    //                                                          break;
    //                                                     }
    //                                                   }
    //                                                   this.offline_drivers = jQuery.grep(this.offline_drivers,function(value){
    //                                                                return value._id != message.o2._id;
    //                                                       });

    //                                                 }
    //                                                 break;
    //                                         }
    //                                 }
    //                          }
    //                     }
    //               }
    //        }
    // })

    // DATE FILTER FOR FILTERING ASSIGNED AND UNASSIGNED TASKS

    $('#header_date_picker').change(() => { });

    // END OF DATE FILTER FOR FILTERING ASSIGNED AND UNASSIGNED TASKS

    $('#hidden_btn').click(() => {
      this.data2 = [];
      this.data1 = [];
      this.data3 = [];
    });

    // this.get_dates();
    this.fname_b = localStorage.getItem('fname');
    this.fmail_b = localStorage.getItem('emailId');
    this.fphone_b = localStorage.getItem('cust_phone');

    jQuery('.phone_num_valid').keyup(function () {
      this.value = this.value.replace(/[^0-9\.]/g, '');
    });

    $('.vehicletypes_but').on('click', 'li', function () {
      $('.btn:first-child').text($(this).text());
      $('.btn:first-child').val($(this).text());
      this.vechicle_type = $(this).attr('id');
      localStorage.setItem('vechileType', this.vechicle_type);
    });

    $('#wght_value, #biding_price input').keypress(function (event) {
      var $this = $(this);
      if (
        (event.which != 46 || $this.val().indexOf('.') != -1) &&
        (event.which < 48 || event.which > 57) &&
        event.which != 0 && event.which != 8
      ) {
        event.preventDefault();
      }

      var text = $(this).val();
      if (event.which == 46 && text.indexOf('.') == -1) {
        setTimeout(function () {
          if ($this.val().substring($this.val().indexOf('.')).length > 3) {
            $this.val($this.val().substring(0, $this.val().indexOf('.') + 3));
          }
        }, 1);
      }

      if (
        text.indexOf('.') != -1 &&
        text.substring(text.indexOf('.')).length > 2 &&
        event.which != 0 && event.which != 8 &&
        $(this)[0].selectionStart >= text.length - 2
      ) {
        event.preventDefault();
      }
    });

    $('#add_popup_but').click(function () {
      // $("#contact-form").valid();
    });

    // $("#credit_card_popup").modal("show");

    $(function () {
      $(document.body).on('show.bs.modal', function () {
        $(document.body).addClass('modal-open');
      });
      $(document.body).on('hide.bs.modal', function () {
        $(document.body).removeClass('modal-open');
      });
    });

    var map;

    jQuery('#back_button').hide();
    // jQuery('#right_back_div').hide();
    jQuery('#right_front_div').show();
    jQuery('.front_div_close').click(function () {
      // jQuery('#right_back_div').toggle();
      //jQuery('#right_front_div').hide();
    });
    jQuery('#right_taks_but').click(function () {
      jQuery('.tasks_list_right').toggle();
    });

    jQuery('#search_picker').click(() => {
      this.data2 = [];
      this.data1 = [];
      this.data3 = [];
      this.picker_bool = true;
      this.picker_date = $('#header_date_picker').val();
      this.drop_date = $('#header_date_picker2').val();
    });

    jQuery('.connections_div').click(function () {
      // jQuery('#right_back_div').toggle();
      jQuery('#right_front_div').show();
    });

    jQuery('#path_history_button').click(() => {
      jQuery('.tabs_details').hide();
      jQuery('.path_history').show();
      jQuery('.details_but_sytle').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery('#job_details_button').click(function () {
      jQuery('.tabs_details').hide();
      jQuery('.details_description').show();
      jQuery('.details_but_sytle').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery('#activity_timeline_button').click(function () {
      jQuery('.tabs_details').hide();
      jQuery('.activity_timeline').show();
      jQuery('.details_but_sytle').removeClass('active');
      jQuery(this).addClass('active');
    });

    $('ul.details_popup_menu').on(
      'click',
      '#activity_timeline_button',
      function () { }
    );

    jQuery('#job_details_button').trigger('click');
    jQuery('#bulk_import_but').click(function () {
      jQuery('#bulk_import_but')
        .find('span')
        .toggleClass('active');
    });

    $('#assigned_but').click(() => {
      this.bookingCount();
      this.getmyjobs(1);
      // const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      //   'rotate_pointer'
      // );
      // console.log('add right', isRightMarkerIsOpen)
      // if (isRightMarkerIsOpen) {
      //   jQuery('.right_marker').trigger('click');
      // }
      $('.common_tasks').hide();
      $('.assigned_jobs').show();
      this.clearallpassdetails();
    });
    $('#un_assigned_but').click(() => {
      this.bookingCount();
      this.getmyjobs(2);
      // const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      //   'rotate_pointer'
      // );
      // if (isRightMarkerIsOpen) {
      //   jQuery('.right_marker').trigger('click');
      // }
      console.log('add right', isRightMarkerIsOpen)
      $('.common_tasks').hide();
      $('.un_assigned_jobs').show();
      this.clearallpassdetails();
    });
    $('#completed_but').click(() => {
      this.bookingCount();
      this.getmyjobs(3);
      // const isRightMarkerIsOpen = jQuery('.right_marker span').hasClass(
      //   'rotate_pointer'
      // );
      // console.log('add right', isRightMarkerIsOpen)
      // if (isRightMarkerIsOpen) {
      //   jQuery('.right_marker').trigger('click');
      // }
      $('.common_tasks').hide();
      $('.completed_jobs').show();
      this.clearallpassdetails();
    });

    jQuery('.width_3').click(function () {
      jQuery('.width_3').removeClass('active');
      jQuery(this).addClass('active');
    });
    jQuery('.width_3_rt').click(function () {
      jQuery('.width_3_rt').removeClass('active');
      jQuery(this).addClass('active');
    });

    $('.assigned_jobs').scroll(() => {
      var height = $('.assigned_jobs').prop('scrollHeight');
      let current = $('.assigned_jobs').scrollTop();
      var bottom = height * 0.8;
      // console.log("reached", current);
      // console.log("bottom", bottom);
      // if (current > bottom && !this.offers_incall) {
      //   this.offers_skip = this.offers_skip + this.offers_limit;
      //   this.offers_incall = true;
      //   this.getslaveappointments();
      // }
    });

    // This example requires the Places library. Include the libraries=places
    // parameter when you first load the API. For example:
    // <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
  }
  refresh_all_fil() {
    this.data2 = [];
    this.data1 = [];
    this.data3 = [];
    this.picker_bool = false;
  }
  clearallpassdetails() {
    this.passDetailsContent = '';
    this.showbooking_content = '';
    this.new_negotiations = [];
    this.old_negotiations = [];
    this.negotiations = [];
    this.shownegos_content = '';
    if (this.allroute_markers.length > 0) {
      for (let inst = 0; inst < this.allroute_markers.length; inst++) {
        this.allroute_markers[inst].setMap(null);
      }
      this.allroute_markers = [];
      //   this.directionsDisplay.setMap(null);
    }
    if (this.showingVehicleMarker != undefined) {
      this.showingVehicleMarker.setMap(null);
      this.showingVehicleMarker = undefined;
    }

    if (this.pathline != undefined) {
      this.pathline.setMap(null);
      this.allpath_markers = [];
    }
    if (this.directionsDisplay != undefined) {
      this.directionsDisplay.setMap(null);
    }
    if (this.path_his.length > 0) {
      for (let inst = 0; inst < this.path_his.length; inst++) {
        this.path_his[inst].setMap(null);
      }
    }
  }

  getmyjobs(val) {
    this.bookingLoader = true;
    if (val == 1) {
      this.offers = [];
    } else if (val == 2) {
      this.assigned_jobs = [];
    } else if (val == 3) {
      this.past_jobs = [];
    }
    // console.log('Get My Jobs ==>', this.offers, this.assigned_jobs, this.past_jobs)
    this._dispatcherHomeService
      .getjobs({
        type: val,
        skip: this.assigned_skip,
        limit: this.assigned_limit
      })
      .subscribe(
        (res: any) => {
          // console.log("myjobs+++++++++++++++", res);
          $('#appt_loader_parent').hide();
          const booking_data = res.data.bookings;
          this.total_assigned_count = res.count;
          if (booking_data.length == 0) {
            // $(".more_tooltip_error").show();
            // setTimeout(function () { $(".more_tooltip_error").hide(); }, 2000);
          } else {
            this.assigned_incall = false;
            for (let inst = 0; inst < booking_data.length; inst++) {
              // converting time stamps to local time using moment
              if (booking_data[inst].bookingDateTimestamp != '0') {
                booking_data[inst].bookingDateTimestamp = moment
                  .unix(booking_data[inst].bookingDateTimestamp)
                  .format('DD MMM  YYYY, hh : mm a');
              }
              if (booking_data[inst].deliveryDateTimestamp != '0') {
                booking_data[inst].deliveryDateTimestamp = moment
                  .unix(booking_data[inst].deliveryDateTimestamp)
                  .format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.created != '0') {
                booking_data[inst].timeStamp.created = moment(
                  booking_data[inst].timeStamp.created * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.expired != 0) {
                booking_data[inst].timeStamp.expired = moment(
                  booking_data[inst].timeStamp.expired * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.cancelled != 0) {
                booking_data[inst].timeStamp.cancelled = moment(
                  booking_data[inst].timeStamp.cancelled * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.accepted != 0) {
                booking_data[inst].timeStamp.accepted = moment(
                  booking_data[inst].timeStamp.accepted * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.arrived != 0) {
                booking_data[inst].timeStamp.arrived = moment(
                  booking_data[inst].timeStamp.arrived * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.reachedDrop != 0) {
                booking_data[inst].timeStamp.reachedDrop = moment(
                  booking_data[inst].timeStamp.reachedDrop * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.onTheWay != 0) {
                booking_data[inst].timeStamp.onTheWay = moment(
                  booking_data[inst].timeStamp.onTheWay * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.unloaded != 0) {
                booking_data[inst].timeStamp.unloaded = moment(
                  booking_data[inst].timeStamp.unloaded * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.journeyComplete != 0) {
                booking_data[inst].timeStamp.journeyComplete = moment(
                  booking_data[inst].timeStamp.journeyComplete * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].timeStamp.journeyStart != 0) {
                booking_data[inst].timeStamp.journeyStart = moment(
                  booking_data[inst].timeStamp.journeyStart * 1000
                ).format('DD MMM YYYY, hh : mm a');
              }
              if (booking_data[inst].activities != undefined) {
                for (
                  let bookingstatus = 0;
                  bookingstatus < booking_data[inst].activities.length;
                  bookingstatus++
                ) {
                  booking_data[inst].activities[
                    bookingstatus
                  ].timeConverted = moment(
                    booking_data[inst].activities[bookingstatus].time
                  ).format('DD MMM YYYY, hh : mm a');
                }
              }
              switch (val) {
                case 1:
                  this.showTimer(booking_data[inst]);
                  this.offers.push(booking_data[inst]);
                  break;
                case 2:
                  this.assigned_jobs.push(booking_data[inst]);
                  break;
                case 3:
                  this.past_jobs.push(booking_data[inst]);
                  break;
              }
              // console.log('booking_data[inst].negotiation', booking_data[inst].negotiation['dispatcherId']);
            }
            // console.log("aftermodifying", booking_data);
          }
          this.map_loader = false;
          this.bookingLoader = false;
        },
        err => {
          this.bookingLoader = false;
          if (err.status == 401) {
            // toastr["error"]("<h5>Logged out</h5>");
            $('#logout_popup').modal({ backdrop: 'static', keyboard: false });
          }
          if (err.status == 400) {
            toastr['error']('<h5>Bad request.. unable to do a request</h5>');
          } else {
            toastr['error'](
              '<h5>Could not connect to server!!! Please try again later</h5>'
            );
          }
          const error = err.error;
          const listErr = error.statusCode;
          this.handleStatus(error.statusCode);
          this.map_loader = false;
        }
      );
  }

  showTimer(data) {
    // console.log(data);
    const bidClosingTime = data.dispatchTime.bidClosingTime;
    const bidExpiryTime = data.dispatchTime.bookingExpiryTime;
    const currentTime = moment().unix();
    const diffbidClosingTime = bidClosingTime - currentTime;
    const diffExpiryTime = bidExpiryTime - currentTime;
    // console.log("diffExpiryTime", diffExpiryTime);
    // console.log("diffBookingExpiryTime", diffbidClosingTime);
    // bid closing time
    if (data.bidding == false) {
      $('#closingTime' + data.bookingId).text('DISABLED');
    }
    if (diffbidClosingTime > 0) {
      if (data.bidding == true) {
        let duration = moment.duration(
          diffbidClosingTime * 1000,
          'milliseconds'
        );
        // console.log("durationClosingTime", duration);
        const interval = 1000;
        const x = setInterval(function () {
          if (duration <= 0) {
            clearInterval(x);
            $('#closingTime' + data.bookingId).text('CLOSED');
            const i = this.intervalTimersArray.findIndex(item => item.id === x);
            if (i !== -1) {
              this.intervalTimersArray.splice(i, 1);
            }
            $('#closingTime' + data.bookingId).text('CLOSED');
          } else {
            duration = moment.duration(duration - interval, 'milliseconds');
            $('#closingTime' + data.bookingId).text(
              duration.days() +
              'd ' +
              ' : ' +
              duration.hours() +
              'h ' +
              ' : ' +
              duration.minutes() +
              'm' +
              ' : ' +
              duration.seconds() +
              's'
            );
          }
        }, interval);
        this.intervalTimersArray.push({ booking: data.bookingId, id: x });
        console.log('SetInterval Added X', this.intervalTimersArray);
      }
    } else {
      setTimeout(function () {
        $('#closingTime' + data.bookingId).text('CLOSED');
      }, 1000);
    }
    if (diffExpiryTime > 0) {
      let duration = moment.duration(diffExpiryTime * 1000, 'milliseconds');
      // console.log("durationExpirytime", duration);
      const interval = 1000;
      const y = setInterval(function () {
        if (duration <= 0) {
          clearInterval(y);
          if (this.intervalTimersArray && this.intervalTimersArray.length > 0) {
            const i = this.intervalTimersArray.findIndex(item => item.id === y);
            if (i !== -1) {
              this.intervalTimersArray.splice(i, 1);
            }
          }
          $('#expiryTime' + data.bookingId).text('EXPIRED');
        } else {
          duration = moment.duration(duration - interval, 'milliseconds');
          $('#expiryTime' + data.bookingId).text(
            duration.days() +
            'd ' +
            ' : ' +
            duration.hours() +
            'h ' +
            ' : ' +
            duration.minutes() +
            'm' +
            ' : ' +
            duration.seconds() +
            's'
          );
        }
      }, interval);
      this.intervalTimersArray.push({ booking: data.bookingId, id: y });
      console.log('SetInterval Added Y', this.intervalTimersArray);
    } else {
      setTimeout(function () {
        $('#expiryTime' + data.bookingId).text('EXPIRED');
      }, 1000);
    }
  }

  zoomin() {
    const m = this.map1.getZoom();
    this.map1.setZoom(m - 1);
  }
  zoomout() {
    const m = this.map1.getZoom();
    this.map1.setZoom(m + 1);
  }

  updateUrl($event) {
    $event.target.src = this.aws + '/img/driver_profile_pic.png';
  }

  updateUrl1($event) {
    $event.target.src = '../../assets/img/truck.png';
  }

  // rating_b_details: any;
  // // single booking api call
  // callsingalbooking(bid) {
  //   this._dispatcherService.getdet({
  //     "ent_page_index": "0",
  //     "ent_booking_id": bid,
  //   }).subscribe((res: any) => {
  //     console.log("singalbooking+++++++++++", res);
  //     if (res.errFlag == 0) {
  //       this.rating_b_details = res.data.appointments[0];
  //       console.log("singalbooking+++++++++++rating_b_details", this.rating_b_details);
  //       setTimeout(() => {
  //         $('#review_popup').modal({ backdrop: 'static', keyboard: false });
  //       }, 200)
  //       console.log("rating_b_details", this.rating_b_details);
  //     } else {
  //       alert(res.errMsg);
  //     }
  //   }, (err) => {
  //     // var error = err.error;
  //     // var listErr = error.statusCode;
  //     // this.handleStatus(error.statusCode);
  //   }
  // );
  // }
  onScroll() {
    console.log('Scrolled!!!');
  }

  emergencyAlertBookings(booking) {
    console.log('id', booking)
    let regData = {
      bookingId: booking.bookingId.toString(),
      userId: this._cookie.getItem('sid')
    }
    this._dispatcherHomeService.emergencyBooking(regData).subscribe((res) => {
      console.log('res emergency', res);
      toastr["success"]("<h5>Emergency alert is  posted</h5>");
    }, err => {
      console.log('error ', err);
      $('.booking_loader_parent').hide();
      const error = err.error;
      const listErr = error.statusCode;
      this.handleStatus(error.statusCode);
    })
  }

  send_otp_to_driver(booking) {
    console.log('id', booking)
    let regData = {
      bookingId: booking.bookingId.toString(),
      userId: booking.driverDetails.driverId,
      code: this.otp_entered,
      trigger: 4
    }
    this._dispatcherHomeService.postJobStartByDriver(regData).subscribe((res) => {
      console.log('res emergency', res);
      toastr['success'](`<h5>${res['message']}</h5>`);
      $('#otp_popup').modal('hide');
    }, err => {
      console.log('error ', err);
      $('.booking_loader_parent').hide();
      const error = err.error;
      const listErr = error.statusCode;
      this.handleStatus(error.statusCode);
    })
  }


  // START OF FAVORITE DRIVER
  getfavdriver() {
    this._dispatcherHomeService.getfavdriver({}).subscribe((res: any) => {
      if (res.data.length > 0) {
        for (let inst = 0; inst < res.data.length; inst++) {
          if (res.data[inst].isOnline == true) {
            this.favDiverId = res.data[inst].driverId;
            if (this.pendingDriverId == res.data[inst].driverId) {
              this.removeFav = true;
            }
          }
        }
      }
    });
  }
  postfavdriver() {
    this._dispatcherHomeService
      .postfavdriver({
        driverId: this.driverId,
      })
      .subscribe((res: any) => {
        this.removeFav = true;
      });
  }
  patchfavdriver() {
    this._dispatcherHomeService
      .patchfavdriver({
        driverId: this.pendingDriverId,
      })
      .subscribe((res: any) => {
        this.removeFav = false;
        for (let inst = 0; inst < res.data.length; inst++) {
          if (res.data[inst].isOnline == true) {
          }
        }
      });
  }
}
